export type Language = "es" | "en" | "ca" | "pt" | "fr" | "it" | "de" | "ru";

export const languageNames: Record<Language, string> = {
  es: "Español",
  en: "English",
  ca: "Català",
  pt: "Português",
  fr: "Français",
  it: "Italiano",
  de: "Deutsch",
  ru: "Русский",
};

export const languageFlags: Record<Language, string> = {
  es: "🇪🇸",
  en: "🇬🇧",
  ca: "🏴",
  pt: "🇵🇹",
  fr: "🇫🇷",
  it: "🇮🇹",
  de: "🇩🇪",
  ru: "🇷🇺",
};

type TranslationKeys = {
  // Nav
  nav_home: string;
  nav_menu: string;
  nav_gallery: string;
  nav_about: string;
  nav_reservations: string;
  nav_contact: string;
  // CTAs
  cta_reserve: string;
  cta_reserve_table: string;
  cta_order_online: string;
  cta_view_menu: string;
  cta_call: string;
  cta_reserve_now: string;
  cta_confirm_reservation: string;
  // Hero
  hero_subtitle: string;
  hero_title: string;
  hero_desc: string;
  // About preview
  about_label: string;
  about_title: string;
  about_p1: string;
  about_p2: string;
  about_more: string;
  // Featured
  featured_label: string;
  featured_title: string;
  featured_see_all: string;
  // Buffet section (homepage)
  buffet_section_label: string;
  buffet_section_title: string;
  buffet_per_person: string;
  buffet_subtitle: string;
  buffet_point_1: string;
  buffet_point_2: string;
  buffet_point_3: string;
  buffet_point_4: string;
  daily_ideal: string;
  // Location
  location_label: string;
  location_title: string;
  // Benefits
  benefits_label: string;
  benefits_title: string;
  benefit_fresh: string;
  benefit_fresh_desc: string;
  benefit_authentic: string;
  benefit_authentic_desc: string;
  benefit_cozy: string;
  benefit_cozy_desc: string;
  benefit_online: string;
  benefit_online_desc: string;
  // Gallery
  gallery_label: string;
  gallery_title: string;
  gallery_see_all: string;
  gallery_prev: string;
  gallery_next: string;
  gallery_close: string;
  gallery_page_title: string;
  gallery_page_heading: string;
  // Reviews
  reviews_label: string;
  reviews_title: string;
  reviews_on_google: string;
  // CTA banner
  cta_banner_title: string;
  cta_banner_desc: string;
  // Menu page
  menu_label: string;
  menu_title: string;
  menu_all: string;
  menu_links_label: string;
  menu_maker: string;
  menu_day: string;
  menu_buffet: string;
  menu_buffet_title: string;
  menu_buffet_price: string;
  menu_buffet_kids: string;
  menu_buffet_note: string;
  menu_buffet_schedule: string;
  menu_daily_title: string;
  menu_daily_price: string;
  menu_daily_note: string;
  menu_daily_schedule: string;
  // About page
  about_page_title: string;
  about_since: string;
  about_passion_title: string;
  about_story_p1: string;
  about_story_p2: string;
  about_story_p3: string;
  about_story_p4: string;
  about_values_label: string;
  about_values_title: string;
  about_val1: string;
  about_val1_desc: string;
  about_val2: string;
  about_val2_desc: string;
  about_val3: string;
  about_val3_desc: string;
  // Reservations page
  res_title: string;
  res_label: string;
  res_heading: string;
  res_name: string;
  res_name_ph: string;
  res_date: string;
  res_time: string;
  res_time_ph: string;
  res_guests: string;
  res_person: string;
  res_persons: string;
  res_phone: string;
  res_phone_ph: string;
  res_notes: string;
  res_notes_ph: string;
  res_success_title: string;
  res_success_desc: string;
  // Contact page
  contact_label: string;
  contact_title: string;
  contact_address: string;
  contact_phone: string;
  contact_email: string;
  contact_hours: string;
  contact_closed: string;
  contact_schedule: string;
  contact_days: string;
  // Footer
  footer_desc: string;
  footer_contact: string;
  footer_hours: string;
  footer_rights: string;
  // Local SEO
  local_why_title: string;
  local_authority_text: string;
  local_near_sants: string;
  local_directions: string;
  reviews_leave_review: string;
  // SEO landing
  seo_landing_title: string;
  seo_landing_desc: string;
  landing_h1: string;
  landing_intro: string;
  landing_buffet_h2: string;
  landing_buffet_text: string;
  landing_daily_h2: string;
  landing_daily_text: string;
  landing_location_h2: string;
  landing_location_text: string;
  landing_why_h2: string;
  landing_why_p1: string;
  landing_why_p2: string;
  landing_why_p3: string;
  landing_why_p4: string;
  landing_why_p5: string;
  landing_cta: string;
  // SEO
  seo_home_title: string;
  seo_home_desc: string;
  seo_menu_title: string;
  seo_menu_desc: string;
  seo_gallery_title: string;
  seo_gallery_desc: string;
  seo_about_title: string;
  seo_about_desc: string;
  seo_res_title: string;
  seo_res_desc: string;
  seo_contact_title: string;
  seo_contact_desc: string;
  // GEO
  geo_find_nearby: string;
  geo_nearby_message: string;
  geo_far_message: string;
  geo_directions: string;
  geo_transport_sants: string;
  geo_transport_espanya: string;
  geo_minutes_away: string;
  // FAQ / AEO
  faq_label: string;
  faq_title: string;
  faq_q1: string;
  faq_a1: string;
  faq_q2: string;
  faq_a2: string;
  faq_q3: string;
  faq_a3: string;
  faq_q4: string;
  faq_a4: string;
  faq_q5: string;
  faq_a5: string;
  faq_q6: string;
  faq_a6: string;
  // Buffet two-tier pricing
  menu_buffet_price_lunch: string;
  menu_buffet_schedule_lunch: string;
  menu_buffet_price_dinner: string;
  menu_buffet_schedule_dinner: string;
  menu_buffet_kids_note: string;
  // Blog
  nav_blog: string;
  blog_title: string;
  blog_heading: string;
  blog_read_more: string;
  blog_back: string;
  blog_reserve_cta: string;
  // Nav extra
  nav_restaurant: string;
  // Footer
  footer_legal: string;
  footer_social: string;
  footer_google_maps: string;
  footer_navigation: string;
  // Local SEO CTA
  local_seo_cta: string;
  // Delivery / Takeaway
  delivery_takeaway_badge: string;
  cta_delivery_title: string;
  cta_delivery_desc: string;
};

const es: TranslationKeys = {
  nav_home: "Inicio",
  nav_menu: "Carta",
  nav_gallery: "Galería",
  nav_about: "Nosotros",
  nav_reservations: "Reservas",
  nav_contact: "Contacto",
  cta_reserve: "Reservar",
  cta_reserve_table: "Reservar mesa",
  cta_order_online: "Ordenar online",
  cta_view_menu: "Ver menú",
  cta_call: "Llamar",
  cta_reserve_now: "Reservar ahora",
  cta_confirm_reservation: "Confirmar reserva",
  hero_subtitle: "Japanese Restaurant · Barcelona",
  hero_title: "Auténtica experiencia japonesa en Barcelona",
  hero_desc: "Ingredientes frescos, recetas tradicionales y un ambiente único en el Barrio de Sants-Montjuïc.",
  about_label: "Nuestra historia",
  about_title: "Tradición y pasión desde 2018",
  about_p1: "Chibikokoro nace en el Barrio de Sants-Montjuïc con la misión de ofrecer una experiencia gastronómica que fusiona los sabores y aromas asiáticos con la auténtica cocina japonesa.",
  about_p2: "Cada plato es una obra de arte, elaborado con ingredientes frescos seleccionados diariamente y técnicas depuradas durante años.",
  about_more: "Conocer más sobre Chibikokoro",
  featured_label: "Nuestra carta",
  featured_title: "Platos destacados",
  featured_see_all: "Ver carta completa",
  benefits_label: "¿Por qué elegirnos?",
  benefits_title: "Nuestra esencia",
  benefit_fresh: "Ingredientes frescos",
  benefit_fresh_desc: "Seleccionamos diariamente los mejores productos del mercado.",
  benefit_authentic: "Recetas auténticas",
  benefit_authentic_desc: "Técnicas japonesas tradicionales con un toque de fusión.",
  benefit_cozy: "Ambiente acogedor",
  benefit_cozy_desc: "Un espacio íntimo pensado para disfrutar cada bocado.",
  benefit_online: "Pedidos online",
  benefit_online_desc: "Delivery y takeaway para disfrutar en casa.",
  gallery_label: "Nuestra galería",
  gallery_title: "El arte en cada plato",
  gallery_see_all: "Ver galería completa",
  gallery_prev: "← Anterior",
  gallery_next: "Siguiente →",
  gallery_close: "Cerrar",
  gallery_page_title: "Galería",
  gallery_page_heading: "Momentos Chibikokoro",
  reviews_label: "Opiniones",
  reviews_title: "Lo que dicen nuestros clientes",
  reviews_on_google: "reseñas en Google",
  cta_banner_title: "Reserva tu mesa hoy",
  cta_banner_desc: "Vive una experiencia gastronómica inolvidable en el corazón de Barcelona.",
  menu_label: "Nuestra carta",
  menu_title: "Sabores de Japón",
  menu_all: "Todos",
  menu_links_label: "Consulta también nuestras cartas completas:",
  menu_maker: "Menú Maker",
  menu_day: "Menú del Día",
  menu_buffet: "Carta Buffet Libre",
  menu_buffet_title: "Buffet libre",
  menu_buffet_price: "Desde 16,99 € por persona",
  menu_buffet_kids: "Buffet Infantil: 11,50 €",
  menu_buffet_note: "Bebida no incluida. Es obligatorio un pedido mínimo de 1 bebida por persona.",
  menu_buffet_schedule: "Todos los días de 13:00 h a 23:00 h",
  menu_daily_title: "Menú diario",
  menu_daily_price: "13,50 € por persona",
  menu_daily_note: "Bebida y postre incluidos",
  menu_daily_schedule: "De lunes a viernes de 13:00 h a 16:00 h",
  about_page_title: "Nuestra Historia",
  about_since: "Desde 2018",
  about_passion_title: "Pasión por el sushi",
  about_story_p1: "El restaurante japonés Sushi Chibikokoro se crea en 2018 en uno de los barrios residenciales más tranquilos de Barcelona, el Barrio de Sants-Montjuïc.",
  about_story_p2: "Nuestro restaurante nace con la intención de ofrecer un estilo gastronómico que fusione los sabores y aromas asiáticos con la cocina japonesa más auténtica.",
  about_story_p3: "Cada plato es elaborado con ingredientes frescos, seleccionados diariamente para garantizar la máxima calidad y frescura en cada bocado.",
  about_story_p4: "Nuestra receta para el éxito es simple: calidad y sabor que hacen que nuestros clientes regresen una y otra vez.",
  about_values_label: "Nuestros valores",
  about_values_title: "Lo que nos define",
  about_val1: "Frescura",
  about_val1_desc: "Ingredientes seleccionados cada mañana en los mejores mercados.",
  about_val2: "Autenticidad",
  about_val2_desc: "Técnicas japonesas tradicionales respetadas en cada preparación.",
  about_val3: "Pasión",
  about_val3_desc: "Amor por la gastronomía japonesa en cada detalle del servicio.",
  res_title: "Reservas",
  res_label: "Reservar mesa",
  res_heading: "Te esperamos",
  res_name: "Nombre",
  res_name_ph: "Tu nombre completo",
  res_date: "Fecha",
  res_time: "Hora",
  res_time_ph: "Seleccionar hora",
  res_guests: "Comensales",
  res_person: "persona",
  res_persons: "personas",
  res_phone: "Teléfono",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Notas (opcional)",
  res_notes_ph: "Alergias, celebraciones, preferencias...",
  res_success_title: "¡Reserva recibida!",
  res_success_desc: "Confirmaremos tu reserva por teléfono lo antes posible. ¡Gracias por elegir Chibikokoro!",
  contact_label: "Contacto",
  contact_title: "Encuéntranos",
  contact_address: "Dirección",
  contact_phone: "Teléfono",
  contact_email: "Email",
  contact_hours: "Horario",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Lunes — Domingo",
  footer_desc: "Auténtica cocina japonesa en el corazón del Barrio de Sants-Montjuïc. Ingredientes frescos, recetas tradicionales, experiencia única.",
  footer_contact: "Contacto",
  footer_hours: "Horario",
  footer_rights: "Todos los derechos reservados.",
  seo_home_title: "Chibikokoro – Restaurante Japonés en Barcelona | Buffet Libre desde 16,99€",
  seo_home_desc: "Restaurante japonés en Barcelona con buffet libre desde 16,99€ y menú diario 13,50€. Sushi fresco y auténtica experiencia japonesa.",
  buffet_section_label: "Nuestras ofertas",
  buffet_section_title: "Buffet Libre y Menú Diario",
  buffet_per_person: "por persona",
  buffet_subtitle: "Disfruta sin límites de nuestra selección de sushi recién preparado y especialidades japonesas auténticas.",
  buffet_point_1: "Sushi preparado al momento",
  buffet_point_2: "Ingredientes frescos y de alta calidad",
  buffet_point_3: "Amplia variedad para todos los gustos",
  buffet_point_4: "Ambiente acogedor y elegante",
  daily_ideal: "Ideal para una comida rápida y de calidad en Barcelona.",
  location_label: "Dónde estamos",
  location_title: "Encuéntranos en Barcelona",
  seo_menu_title: "Carta — Chibikokoro | Sushi y Cocina Japonesa Barcelona",
  seo_menu_desc: "Descubre nuestra carta de sushi, sashimi, nigiri, rolls, platos calientes y postres. Ingredientes frescos y recetas auténticas japonesas en el Barrio de Sants-Montjuïc.",
  seo_gallery_title: "Galería — Chibikokoro | Fotos del Restaurante",
  seo_gallery_desc: "Descubre nuestra galería de fotos. Platos, ambiente y momentos únicos en Chibikokoro, restaurante japonés en Barcelona.",
  seo_about_title: "Sobre Nosotros — Chibikokoro | Restaurante Japonés Barcelona",
  seo_about_desc: "Conoce la historia de Chibikokoro. Desde 2018, ofrecemos auténtica cocina japonesa con ingredientes frescos en el Barrio de Sants-Montjuïc, Barcelona.",
  seo_res_title: "Reservas — Chibikokoro | Reserva tu Mesa en Barcelona",
  seo_res_desc: "Reserva tu mesa en Chibikokoro. Restaurante japonés en el Barrio de Sants-Montjuïc, Barcelona. Sushi, sashimi y cocina japonesa auténtica.",
  seo_contact_title: "Contacto — Chibikokoro | Restaurante Japonés Barcelona",
  seo_contact_desc: "Contacta con Chibikokoro. Dirección, teléfono, email y horarios. Restaurante japonés en el Barrio de Sants-Montjuïc, Barcelona.",
  local_why_title: "¿Por qué elegir nuestro restaurante japonés en Barcelona?",
  local_authority_text: "Ubicados en el Barrio de Sants-Montjuïc, a pocos minutos de la Estación de Sants y Plaça d'Espanya, Chibikokoro es la opción ideal para disfrutar del mejor sushi en Barcelona. Ofrecemos buffet libre japonés económico, ingredientes frescos de primera calidad y un ambiente acogedor perfecto para familias, parejas y grupos.",
  local_near_sants: "Cerca de Estación de Sants y Plaça d'Espanya",
  local_directions: "Cómo llegar",
  reviews_leave_review: "Déjanos tu reseña en Google",
  seo_landing_title: "Restaurante Japonés en Barcelona | Chibikokoro – Sushi y Buffet Libre",
  seo_landing_desc: "Descubre Chibikokoro, el mejor restaurante japonés en Barcelona. Buffet libre desde 16,99€, menú diario 13,50€. Sushi fresco cerca de la Estación de Sants y Plaça d'Espanya.",
  landing_h1: "Restaurante Japonés en Barcelona – Chibikokoro",
  landing_intro: "Bienvenido a Chibikokoro, tu restaurante japonés de referencia en Barcelona. Situados en el Barrio de Sants-Montjuïc, ofrecemos una experiencia gastronómica auténtica con sushi fresco, platos tradicionales japoneses y un ambiente acogedor. A pocos pasos de la Estación de Sants y Plaça d'Espanya, somos la elección perfecta para quienes buscan el mejor sushi en Barcelona.",
  landing_buffet_h2: "Buffet Libre Japonés en Barcelona – desde 16,99€",
  landing_buffet_text: "Nuestro buffet libre japonés desde solo 16,99€ por persona (lunes a viernes de 13:00 a 18:00) es una de las mejores ofertas gastronómicas de Barcelona. En horario nocturno, fines de semana y festivos, 19,99€. Disfruta de sushi preparado al momento, nigiri, sashimi, rolls, platos calientes y mucho más. Infantil de 3 a 8 años: 11,50€. No incluye bebida ni postre.",
  landing_daily_h2: "Menú Diario en Barcelona – 13,50€",
  landing_daily_text: "De lunes a viernes, de 13:00 a 16:00, disfruta de nuestro menú diario por 13,50€ con bebida y postre incluidos. Perfecto para una comida rápida y de calidad cerca de la Estación de Sants. Un menú del día japonés que combina sabor, frescura y un precio accesible.",
  landing_location_h2: "Dónde Estamos – Restaurante Japonés cerca de la Estación de Sants",
  landing_location_text: "Chibikokoro se encuentra en Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelona, en el corazón del Barrio de Sants-Montjuïc. Estamos a solo 5 minutos andando de la Estación de Sants y muy cerca de Plaça d'Espanya. Fácil acceso en metro, bus y tren.",
  landing_why_h2: "¿Por qué elegir Chibikokoro?",
  landing_why_p1: "Ubicación céntrica en Barcelona, cerca de la Estación de Sants y Plaça d'Espanya",
  landing_why_p2: "Buffet libre japonés económico y de alta calidad",
  landing_why_p3: "Ingredientes frescos seleccionados cada día",
  landing_why_p4: "Ambiente acogedor ideal para familias y parejas",
  landing_why_p5: "Pedidos online y reservas fáciles",
  landing_cta: "Reserva tu mesa y descubre por qué somos uno de los restaurantes japoneses favoritos de Barcelona.",
  geo_find_nearby: "¿Estás cerca? Descúbrelo",
  geo_nearby_message: "Estás cerca de nuestro restaurante en Barcelona – ¡Reserva ahora!",
  geo_far_message: "Descubre nuestro restaurante japonés en Barcelona",
  geo_directions: "Cómo llegar",
  geo_transport_sants: "A 5 min de Estación de Sants",
  geo_transport_espanya: "Cerca de Plaça d'Espanya",
  geo_minutes_away: "min andando",
  faq_label: "Preguntas frecuentes",
  faq_title: "Todo lo que necesitas saber",
  faq_q1: "¿Cuál es el mejor restaurante japonés en Barcelona?",
  faq_a1: "Chibikokoro es uno de los restaurantes japoneses mejor valorados en Barcelona, ofreciendo sushi fresco, buffet libre y menú diario en un ambiente acogedor cerca de la Estación de Sants.",
  faq_q2: "¿Cuánto cuesta el buffet libre japonés en Chibikokoro?",
  faq_a2: "En Chibikokoro puedes disfrutar de un buffet libre japonés por 16,99€ por persona, de lunes a viernes de 13:00h a 18:00h. Infantil de 3 a 8 años, 11,50€. No incluye ni bebida ni postres. En horario nocturno, fines de semana y festivos, el buffet libre japonés es 19,99€ por persona e Infantil de 3 a 8 años, 11,50€. No incluye ni bebida ni postres.",
  faq_q3: "¿Dónde comer sushi cerca de la Estación de Sants?",
  faq_a3: "Nuestro restaurante está ubicado en Carrer de Béjar, 64, Sants-Montjuïc, a pocos minutos caminando de la Estación de Sants y Plaça d'Espanya.",
  faq_q4: "¿Hay menú diario japonés en Barcelona?",
  faq_a4: "Sí, ofrecemos un menú diario por 13,50€ que incluye bebida y postre, de lunes a viernes de 13:00h a 16:00h. Ideal para una comida rápida y de calidad.",
  faq_q5: "¿Se puede reservar mesa online en Chibikokoro?",
  faq_a5: "Sí, puedes reservar mesa fácilmente a través de nuestra web o llamando al +34 931 46 30 45. También aceptamos reservas por WhatsApp al +34 653 53 83 28.",
  faq_q6: "¿Cuál es el horario de Chibikokoro?",
  faq_a6: "Estamos abiertos de lunes a domingo de 13:00h a 23:00h. El menú diario está disponible de lunes a viernes de 13:00h a 16:00h.",
  menu_buffet_price_lunch: "16,99 € por persona",
  menu_buffet_schedule_lunch: "Lunes a viernes de 13:00 h a 18:00 h",
  menu_buffet_price_dinner: "19,99 € por persona",
  menu_buffet_schedule_dinner: "Noches, fines de semana y festivos",
  menu_buffet_kids_note: "Infantil (3-8 años): 11,50 €. No incluye bebida ni postre.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Restaurante Japonés Barcelona",
  blog_heading: "Blog Chibikokoro",
  blog_read_more: "Leer más",
  blog_back: "← Volver al blog",
  blog_reserve_cta: "¿Te apetece sushi? Reserva tu mesa ahora",
  nav_restaurant: "Restaurante en Barcelona",
  footer_legal: "Legal",
  footer_social: "Síguenos",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navegación",
  local_seo_cta: "Descubre nuestro restaurante japonés en Barcelona",
  delivery_takeaway_badge: "Delivery y Takeaway disponible",
  cta_delivery_title: "Pide para llevar o a domicilio",
  cta_delivery_desc: "Disfruta de nuestra cocina japonesa donde quieras. Pedidos online con entrega a domicilio o recogida en restaurante.",
};

const en: TranslationKeys = {
  nav_home: "Home",
  nav_menu: "Menu",
  nav_gallery: "Gallery",
  nav_about: "About",
  nav_reservations: "Reservations",
  nav_contact: "Contact",
  cta_reserve: "Reserve",
  cta_reserve_table: "Reserve a table",
  cta_order_online: "Order online",
  cta_view_menu: "View menu",
  cta_call: "Call",
  cta_reserve_now: "Reserve now",
  cta_confirm_reservation: "Confirm reservation",
  hero_subtitle: "Japanese Restaurant · Barcelona",
  hero_title: "Authentic Japanese experience in Barcelona",
  hero_desc: "Fresh ingredients, traditional recipes and a unique atmosphere in the Sants-Montjuïc neighborhood.",
  about_label: "Our story",
  about_title: "Tradition and passion since 2018",
  about_p1: "Chibikokoro was born in the Sants-Montjuïc neighborhood with the mission to offer a gastronomic experience that fuses Asian flavors and aromas with authentic Japanese cuisine.",
  about_p2: "Each dish is a work of art, crafted with fresh ingredients selected daily and techniques refined over the years.",
  about_more: "Learn more about Chibikokoro",
  featured_label: "Our menu",
  featured_title: "Featured dishes",
  featured_see_all: "View full menu",
  benefits_label: "Why choose us?",
  benefits_title: "Our essence",
  benefit_fresh: "Fresh ingredients",
  benefit_fresh_desc: "We select the best products from the market every day.",
  benefit_authentic: "Authentic recipes",
  benefit_authentic_desc: "Traditional Japanese techniques with a fusion touch.",
  benefit_cozy: "Cozy atmosphere",
  benefit_cozy_desc: "An intimate space designed to enjoy every bite.",
  benefit_online: "Online orders",
  benefit_online_desc: "Delivery and takeaway to enjoy at home.",
  gallery_label: "Our gallery",
  gallery_title: "The art in every dish",
  gallery_see_all: "View full gallery",
  gallery_prev: "← Previous",
  gallery_next: "Next →",
  gallery_close: "Close",
  gallery_page_title: "Gallery",
  gallery_page_heading: "Chibikokoro moments",
  reviews_label: "Reviews",
  reviews_title: "What our customers say",
  reviews_on_google: "reviews on Google",
  cta_banner_title: "Reserve your table today",
  cta_banner_desc: "Live an unforgettable gastronomic experience in the heart of Barcelona.",
  menu_label: "Our menu",
  menu_title: "Flavors of Japan",
  menu_all: "All",
  menu_links_label: "Also check our complete menus:",
  menu_maker: "Menu Maker",
  menu_day: "Daily Menu",
  menu_buffet: "Buffet Menu",
  menu_buffet_title: "All-you-can-eat Buffet",
  menu_buffet_price: "From €16.99 per person",
  menu_buffet_kids: "Kids Buffet: €11.50",
  menu_buffet_note: "Drinks not included. Minimum 1 drink per person required.",
  menu_buffet_schedule: "Monday to Sunday from 1:00 PM to 11:00 PM",
  menu_daily_title: "Daily Menu",
  menu_daily_price: "€13.50 per person",
  menu_daily_note: "Drink and dessert included",
  menu_daily_schedule: "Monday to Friday from 1:00 PM to 4:00 PM",
  about_page_title: "Our Story",
  about_since: "Since 2018",
  about_passion_title: "Passion for sushi",
  about_story_p1: "Sushi Chibikokoro Japanese restaurant was created in 2018 in one of Barcelona's quietest residential neighborhoods, the Sants-Montjuïc district.",
  about_story_p2: "Our restaurant was born with the intention of offering a gastronomic style that fuses Asian flavors and aromas with the most authentic Japanese cuisine.",
  about_story_p3: "Each dish is prepared with fresh ingredients, selected daily to guarantee the highest quality and freshness in every bite.",
  about_story_p4: "Our recipe for success is simple: quality and flavor that make our customers come back again and again.",
  about_values_label: "Our values",
  about_values_title: "What defines us",
  about_val1: "Freshness",
  about_val1_desc: "Ingredients selected every morning from the best markets.",
  about_val2: "Authenticity",
  about_val2_desc: "Traditional Japanese techniques respected in every preparation.",
  about_val3: "Passion",
  about_val3_desc: "Love for Japanese gastronomy in every detail of our service.",
  res_title: "Reservations",
  res_label: "Reserve a table",
  res_heading: "We're waiting for you",
  res_name: "Name",
  res_name_ph: "Your full name",
  res_date: "Date",
  res_time: "Time",
  res_time_ph: "Select time",
  res_guests: "Guests",
  res_person: "person",
  res_persons: "people",
  res_phone: "Phone",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Notes (optional)",
  res_notes_ph: "Allergies, celebrations, preferences...",
  res_success_title: "Reservation received!",
  res_success_desc: "We will confirm your reservation by phone as soon as possible. Thank you for choosing Chibikokoro!",
  contact_label: "Contact",
  contact_title: "Find us",
  contact_address: "Address",
  contact_phone: "Phone",
  contact_email: "Email",
  contact_hours: "Hours",
  contact_closed: "",
  contact_schedule: "1:00 PM — 11:00 PM",
  contact_days: "Monday — Sunday",
  footer_desc: "Authentic Japanese cuisine in the heart of the Sants-Montjuïc neighborhood. Fresh ingredients, traditional recipes, unique experience.",
  footer_contact: "Contact",
  footer_hours: "Hours",
  footer_rights: "All rights reserved.",
  seo_home_title: "Chibikokoro – Japanese Restaurant in Barcelona | Buffet from €16.99",
  seo_home_desc: "Japanese restaurant in Barcelona with all-you-can-eat buffet from €16.99 and daily menu €13.50. Fresh sushi and authentic Japanese experience.",
  buffet_section_label: "Our offers",
  buffet_section_title: "All-You-Can-Eat Buffet & Daily Menu",
  buffet_per_person: "per person",
  buffet_subtitle: "Enjoy unlimited freshly prepared sushi and authentic Japanese specialties.",
  buffet_point_1: "Sushi prepared to order",
  buffet_point_2: "Fresh, high-quality ingredients",
  buffet_point_3: "Wide variety for all tastes",
  buffet_point_4: "Cozy and elegant atmosphere",
  daily_ideal: "Perfect for a quick, quality lunch in Barcelona.",
  location_label: "Where we are",
  location_title: "Find Us in Barcelona",
  seo_menu_title: "Menu — Chibikokoro | Sushi & Japanese Cuisine Barcelona",
  seo_menu_desc: "Discover our sushi, sashimi, nigiri, rolls, hot dishes and desserts menu. Fresh ingredients and authentic Japanese recipes in Barcelona.",
  seo_gallery_title: "Gallery — Chibikokoro | Restaurant Photos",
  seo_gallery_desc: "Discover our photo gallery. Dishes, atmosphere and unique moments at Chibikokoro, Japanese restaurant in Barcelona.",
  seo_about_title: "About Us — Chibikokoro | Japanese Restaurant Barcelona",
  seo_about_desc: "Learn about Chibikokoro's story. Since 2018, offering authentic Japanese cuisine with fresh ingredients in Barcelona.",
  seo_res_title: "Reservations — Chibikokoro | Reserve Your Table in Barcelona",
  seo_res_desc: "Reserve your table at Chibikokoro. Japanese restaurant in the Sants-Montjuïc neighborhood, Barcelona.",
  seo_contact_title: "Contact — Chibikokoro | Japanese Restaurant Barcelona",
  seo_contact_desc: "Contact Chibikokoro. Address, phone, email and hours. Japanese restaurant in Barcelona.",
  local_why_title: "Why choose our Japanese restaurant in Barcelona?",
  local_authority_text: "Located in the Sants-Montjuïc neighborhood, just minutes from Sants Station and Plaça d'Espanya, Chibikokoro is the ideal choice for the best sushi in Barcelona. We offer an affordable Japanese all-you-can-eat buffet, premium fresh ingredients and a cozy atmosphere perfect for families, couples and groups.",
  local_near_sants: "Near Sants Station and Plaça d'Espanya",
  local_directions: "Get directions",
  reviews_leave_review: "Leave us a review on Google",
  seo_landing_title: "Japanese Restaurant in Barcelona | Chibikokoro – Sushi & Buffet",
  seo_landing_desc: "Discover Chibikokoro, the best Japanese restaurant in Barcelona. All-you-can-eat buffet from €16.99, daily menu €13.50. Fresh sushi near Sants Station.",
  landing_h1: "Japanese Restaurant in Barcelona – Chibikokoro",
  landing_intro: "Welcome to Chibikokoro, your go-to Japanese restaurant in Barcelona. Located in the Sants-Montjuïc neighborhood, we offer an authentic dining experience with fresh sushi, traditional Japanese dishes and a cozy atmosphere. Just steps from Sants Station and Plaça d'Espanya.",
  landing_buffet_h2: "Japanese All-You-Can-Eat Buffet in Barcelona – from €16.99",
  landing_buffet_text: "Our Japanese all-you-can-eat buffet from just €16.99 per person (Mon-Fri 1:00 PM to 6:00 PM) is one of Barcelona's best dining deals. Evenings, weekends and holidays: €19.99. Children aged 3-8: €11.50. Drinks and desserts not included.",
  landing_daily_h2: "Daily Menu in Barcelona – €13.50",
  landing_daily_text: "Monday to Friday from 1:00 PM to 4:00 PM, enjoy our daily menu for €13.50 including drink and dessert. Perfect for a quick, quality lunch near Sants Station.",
  landing_location_h2: "Where We Are – Japanese Restaurant near Sants Station",
  landing_location_text: "Chibikokoro is located at Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelona, in the heart of the Sants-Montjuïc neighborhood. Just 5 minutes walking from Sants Station and very close to Plaça d'Espanya.",
  landing_why_h2: "Why Choose Chibikokoro?",
  landing_why_p1: "Central location in Barcelona, near Sants Station and Plaça d'Espanya",
  landing_why_p2: "Affordable, high-quality Japanese all-you-can-eat buffet",
  landing_why_p3: "Fresh ingredients selected daily",
  landing_why_p4: "Cozy atmosphere perfect for families and couples",
  landing_why_p5: "Easy online ordering and reservations",
  landing_cta: "Reserve your table and discover why we're one of Barcelona's favorite Japanese restaurants.",
  geo_find_nearby: "Are you nearby? Find out",
  geo_nearby_message: "You're close to our restaurant in Barcelona – Reserve now!",
  geo_far_message: "Discover our Japanese restaurant in Barcelona",
  geo_directions: "Get directions",
  geo_transport_sants: "5 min from Sants Station",
  geo_transport_espanya: "Near Plaça d'Espanya",
  geo_minutes_away: "min walk",
  faq_label: "FAQ",
  faq_title: "Everything you need to know",
  faq_q1: "What is the best Japanese restaurant in Barcelona?",
  faq_a1: "Chibikokoro is one of the highest-rated Japanese restaurants in Barcelona, offering fresh sushi, all-you-can-eat buffet and daily menu in a cozy atmosphere near Sants Station.",
  faq_q2: "How much does the Japanese buffet cost at Chibikokoro?",
  faq_a2: "At Chibikokoro you can enjoy a Japanese all-you-can-eat buffet for €16.99 per person, Monday to Friday from 1:00 PM to 6:00 PM. Children aged 3-8, €11.50. Drinks and desserts not included. Evenings, weekends and holidays: €19.99 per person. Children aged 3-8, €11.50. Drinks and desserts not included.",
  faq_q3: "Where to eat sushi near Sants Station?",
  faq_a3: "Our restaurant is located at Carrer de Béjar, 64, Sants-Montjuïc, just a few minutes' walk from Sants Station and Plaça d'Espanya.",
  faq_q4: "Is there a daily menu in Barcelona?",
  faq_a4: "Yes, we offer a daily menu for €13.50 including drink and dessert, Monday to Friday from 1:00 PM to 4:00 PM. Perfect for a quick, quality lunch.",
  faq_q5: "Can I book a table online at Chibikokoro?",
  faq_a5: "Yes, you can easily reserve a table through our website or by calling +34 931 46 30 45. We also accept reservations via WhatsApp at +34 653 53 83 28.",
  faq_q6: "What are Chibikokoro's opening hours?",
  faq_a6: "We are open Monday to Sunday from 1:00 PM to 11:00 PM. The daily menu is available Monday to Friday from 1:00 PM to 4:00 PM.",
  menu_buffet_price_lunch: "€16.99 per person",
  menu_buffet_schedule_lunch: "Monday to Friday 1:00 PM to 6:00 PM",
  menu_buffet_price_dinner: "€19.99 per person",
  menu_buffet_schedule_dinner: "Evenings, weekends and holidays",
  menu_buffet_kids_note: "Children (3-8 years): €11.50. Drinks and desserts not included.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Japanese Restaurant Barcelona",
  blog_heading: "Chibikokoro Blog",
  blog_read_more: "Read more",
  blog_back: "← Back to blog",
  blog_reserve_cta: "Craving sushi? Reserve your table now",
  nav_restaurant: "Restaurant in Barcelona",
  footer_legal: "Legal",
  footer_social: "Follow Us",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navigation",
  local_seo_cta: "Discover our Japanese restaurant in Barcelona",
  delivery_takeaway_badge: "Delivery & Takeaway available",
  cta_delivery_title: "Order for takeaway or delivery",
  cta_delivery_desc: "Enjoy our Japanese cuisine wherever you are. Online orders with home delivery or restaurant pickup.",
};

const ca: TranslationKeys = {
  nav_home: "Inici",
  nav_menu: "Carta",
  nav_gallery: "Galeria",
  nav_about: "Nosaltres",
  nav_reservations: "Reserves",
  nav_contact: "Contacte",
  cta_reserve: "Reservar",
  cta_reserve_table: "Reservar taula",
  cta_order_online: "Demanar online",
  cta_view_menu: "Veure menú",
  cta_call: "Trucar",
  cta_reserve_now: "Reservar ara",
  cta_confirm_reservation: "Confirmar reserva",
  hero_subtitle: "Japanese Restaurant · Barcelona",
  hero_title: "Autèntica experiència japonesa a Barcelona",
  hero_desc: "Ingredients frescos, receptes tradicionals i un ambient únic al Barri de Sants-Montjuïc.",
  about_label: "La nostra història",
  about_title: "Tradició i passió des de 2018",
  about_p1: "Chibikokoro neix al Barri de Sants-Montjuïc amb la missió d'oferir una experiència gastronòmica que fusiona els sabors i aromes asiàtics amb l'autèntica cuina japonesa.",
  about_p2: "Cada plat és una obra d'art, elaborat amb ingredients frescos seleccionats diàriament i tècniques depurades durant anys.",
  about_more: "Saber-ne més sobre Chibikokoro",
  featured_label: "La nostra carta",
  featured_title: "Plats destacats",
  featured_see_all: "Veure carta completa",
  benefits_label: "Per què triar-nos?",
  benefits_title: "La nostra essència",
  benefit_fresh: "Ingredients frescos",
  benefit_fresh_desc: "Seleccionem diàriament els millors productes del mercat.",
  benefit_authentic: "Receptes autèntiques",
  benefit_authentic_desc: "Tècniques japoneses tradicionals amb un toc de fusió.",
  benefit_cozy: "Ambient acollidor",
  benefit_cozy_desc: "Un espai íntim pensat per gaudir de cada mos.",
  benefit_online: "Comandes online",
  benefit_online_desc: "Delivery i takeaway per gaudir a casa.",
  gallery_label: "La nostra galeria",
  gallery_title: "L'art a cada plat",
  gallery_see_all: "Veure galeria completa",
  gallery_prev: "← Anterior",
  gallery_next: "Següent →",
  gallery_close: "Tancar",
  gallery_page_title: "Galeria",
  gallery_page_heading: "Moments Chibikokoro",
  reviews_label: "Opinions",
  reviews_title: "Què diuen els nostres clients",
  reviews_on_google: "ressenyes a Google",
  cta_banner_title: "Reserva la teva taula avui",
  cta_banner_desc: "Viu una experiència gastronòmica inoblidable al cor de Barcelona.",
  menu_label: "La nostra carta",
  menu_title: "Sabors del Japó",
  menu_all: "Tots",
  menu_links_label: "Consulta també les nostres cartes completes:",
  menu_maker: "Menú Maker",
  menu_day: "Menú del Dia",
  menu_buffet: "Carta Bufet Lliure",
  menu_buffet_title: "Bufet lliure",
  menu_buffet_price: "Des de 16,99 € per persona",
  menu_buffet_kids: "Bufet Infantil: 11,50 €",
  menu_buffet_note: "Beguda no inclosa. És obligatori un mínim d'1 beguda per persona.",
  menu_buffet_schedule: "De dilluns a diumenge de 13:00 h a 23:00 h",
  menu_daily_title: "Menú diari",
  menu_daily_price: "13,50 € per persona",
  menu_daily_note: "Beguda i postres inclosos",
  menu_daily_schedule: "De dilluns a divendres de 13:00 h a 16:00 h",
  about_page_title: "La nostra història",
  about_since: "Des de 2018",
  about_passion_title: "Passió pel sushi",
  about_story_p1: "El restaurant japonès Sushi Chibikokoro es crea el 2018 en un dels barris residencials més tranquils de Barcelona, el Barri de Sants-Montjuïc.",
  about_story_p2: "El nostre restaurant neix amb la intenció d'oferir un estil gastronòmic que fusioni els sabors i aromes asiàtics amb la cuina japonesa més autèntica.",
  about_story_p3: "Cada plat és elaborat amb ingredients frescos, seleccionats diàriament per garantir la màxima qualitat i frescor a cada mos.",
  about_story_p4: "La nostra recepta per a l'èxit és simple: qualitat i sabor que fan que els nostres clients tornin una i altra vegada.",
  about_values_label: "Els nostres valors",
  about_values_title: "El que ens defineix",
  about_val1: "Frescor",
  about_val1_desc: "Ingredients seleccionats cada matí als millors mercats.",
  about_val2: "Autenticitat",
  about_val2_desc: "Tècniques japoneses tradicionals respectades a cada preparació.",
  about_val3: "Passió",
  about_val3_desc: "Amor per la gastronomia japonesa a cada detall del servei.",
  res_title: "Reserves",
  res_label: "Reservar taula",
  res_heading: "T'esperem",
  res_name: "Nom",
  res_name_ph: "El teu nom complet",
  res_date: "Data",
  res_time: "Hora",
  res_time_ph: "Seleccionar hora",
  res_guests: "Comensals",
  res_person: "persona",
  res_persons: "persones",
  res_phone: "Telèfon",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Notes (opcional)",
  res_notes_ph: "Al·lèrgies, celebracions, preferències...",
  res_success_title: "Reserva rebuda!",
  res_success_desc: "Confirmarem la teva reserva per telèfon el més aviat possible. Gràcies per triar Chibikokoro!",
  contact_label: "Contacte",
  contact_title: "Troba'ns",
  contact_address: "Adreça",
  contact_phone: "Telèfon",
  contact_email: "Email",
  contact_hours: "Horari",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Dilluns — Diumenge",
  footer_desc: "Autèntica cuina japonesa al cor del Barri de Sants-Montjuïc. Ingredients frescos, receptes tradicionals, experiència única.",
  footer_contact: "Contacte",
  footer_hours: "Horari",
  footer_rights: "Tots els drets reservats.",
  seo_home_title: "Chibikokoro – Japanese Restaurant a Barcelona",
  seo_home_desc: "Restaurant japonès a Barcelona amb bufet lliure des de 16,99€ i menú diari 13,50€.",
  buffet_section_label: "Les nostres ofertes",
  buffet_section_title: "Bufet Lliure i Menú Diari",
  buffet_per_person: "per persona",
  buffet_subtitle: "Gaudeix sense límits de la nostra selecció de sushi acabat de preparar i especialitats japoneses autèntiques.",
  buffet_point_1: "Sushi preparat al moment",
  buffet_point_2: "Ingredients frescos i d'alta qualitat",
  buffet_point_3: "Àmplia varietat per a tots els gustos",
  buffet_point_4: "Ambient acollidor i elegant",
  daily_ideal: "Ideal per a un dinar ràpid i de qualitat a Barcelona.",
  location_label: "On som",
  location_title: "Troba'ns a Barcelona",
  seo_menu_title: "Carta — Chibikokoro | Sushi i Cuina Japonesa Barcelona",
  seo_menu_desc: "Descobreix la nostra carta de sushi, sashimi, nigiri, rolls, plats calents i postres a Barcelona.",
  seo_gallery_title: "Galeria — Chibikokoro | Fotos del Restaurant",
  seo_gallery_desc: "Descobreix la nostra galeria de fotos. Plats, ambient i moments únics a Chibikokoro.",
  seo_about_title: "Sobre Nosaltres — Chibikokoro | Restaurant Japonès Barcelona",
  seo_about_desc: "Coneix la història de Chibikokoro. Des de 2018, cuina japonesa autèntica a Barcelona.",
  seo_res_title: "Reserves — Chibikokoro | Reserva la Teva Taula a Barcelona",
  seo_res_desc: "Reserva la teva taula a Chibikokoro. Restaurant japonès al Barri de Sants-Montjuïc, Barcelona.",
  seo_contact_title: "Contacte — Chibikokoro | Restaurant Japonès Barcelona",
  seo_contact_desc: "Contacta amb Chibikokoro. Adreça, telèfon, email i horaris a Barcelona.",
  local_why_title: "Per què triar el nostre restaurant japonès a Barcelona?",
  local_authority_text: "Ubicats al Barri de Sants-Montjuïc, a pocs minuts de l'Estació de Sants i Plaça d'Espanya, Chibikokoro és l'opció ideal per gaudir del millor sushi a Barcelona.",
  local_near_sants: "A prop de l'Estació de Sants i Plaça d'Espanya",
  local_directions: "Com arribar-hi",
  reviews_leave_review: "Deixa'ns la teva ressenya a Google",
  seo_landing_title: "Restaurant Japonès a Barcelona | Chibikokoro – Sushi i Bufet Lliure",
  seo_landing_desc: "Descobreix Chibikokoro, el millor restaurant japonès a Barcelona. Bufet lliure des de 16,99€, menú diari 13,50€.",
  landing_h1: "Restaurant Japonès a Barcelona – Chibikokoro",
  landing_intro: "Benvingut a Chibikokoro, el teu restaurant japonès de referència a Barcelona. Situats al Barri de Sants-Montjuïc, oferim una experiència gastronòmica autèntica amb sushi fresc i plats tradicionals japonesos.",
  landing_buffet_h2: "Bufet Lliure Japonès a Barcelona – des de 16,99€",
  landing_buffet_text: "El nostre bufet lliure japonès des de 16,99€ per persona (dilluns a divendres de 13:00 a 18:00). Nits, caps de setmana i festius: 19,99€. Infantil de 3 a 8 anys: 11,50€. No inclou beguda ni postres.",
  landing_daily_h2: "Menú Diari a Barcelona – 13,50€",
  landing_daily_text: "De dilluns a divendres, de 13:00 a 16:00, gaudeix del nostre menú diari per 13,50€ amb beguda i postres inclosos.",
  landing_location_h2: "On Som – Restaurant Japonès a prop de l'Estació de Sants",
  landing_location_text: "Chibikokoro es troba al Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelona, al cor del Barri de Sants-Montjuïc. A 5 minuts de l'Estació de Sants.",
  landing_why_h2: "Per què triar Chibikokoro?",
  landing_why_p1: "Ubicació cèntrica a Barcelona, a prop de l'Estació de Sants i Plaça d'Espanya",
  landing_why_p2: "Bufet lliure japonès econòmic i d'alta qualitat",
  landing_why_p3: "Ingredients frescos seleccionats cada dia",
  landing_why_p4: "Ambient acollidor ideal per a famílies i parelles",
  landing_why_p5: "Comandes en línia i reserves fàcils",
  landing_cta: "Reserva la teva taula i descobreix per què som un dels restaurants japonesos preferits de Barcelona.",
  geo_find_nearby: "Ets a prop? Descobreix-ho",
  geo_nearby_message: "Ets a prop del nostre restaurant a Barcelona – Reserva ara!",
  geo_far_message: "Descobreix el nostre restaurant japonès a Barcelona",
  geo_directions: "Com arribar-hi",
  geo_transport_sants: "A 5 min de l'Estació de Sants",
  geo_transport_espanya: "A prop de Plaça d'Espanya",
  geo_minutes_away: "min caminant",
  faq_label: "Preguntes freqüents",
  faq_title: "Tot el que necessites saber",
  faq_q1: "Quin és el millor restaurant japonès a Barcelona?",
  faq_a1: "Chibikokoro és un dels restaurants japonesos més ben valorats de Barcelona, oferint sushi fresc, bufet lliure i menú diari en un ambient acollidor a prop de l'Estació de Sants.",
  faq_q2: "Quant costa el bufet lliure japonès a Chibikokoro?",
  faq_a2: "A Chibikokoro pots gaudir d'un bufet lliure japonès per 16,99€ per persona, de dilluns a divendres de 13:00h a 18:00h. Infantil de 3 a 8 anys, 11,50€. Nits, caps de setmana i festius: 19,99€. No inclou ni beguda ni postres.",
  faq_q3: "On menjar sushi a prop de l'Estació de Sants?",
  faq_a3: "El nostre restaurant es troba al Carrer de Béjar, 64, Sants-Montjuïc, a pocs minuts caminant de l'Estació de Sants i Plaça d'Espanya.",
  faq_q4: "Hi ha menú diari japonès a Barcelona?",
  faq_a4: "Sí, oferim un menú diari per 13,50€ que inclou beguda i postres, de dilluns a divendres de 13:00h a 16:00h.",
  faq_q5: "Es pot reservar taula online a Chibikokoro?",
  faq_a5: "Sí, pots reservar taula fàcilment a través del nostre web o trucant al +34 931 46 30 45. També acceptem reserves per WhatsApp al +34 653 53 83 28.",
  faq_q6: "Quin és l'horari de Chibikokoro?",
  faq_a6: "Estem oberts de dilluns a diumenge de 13:00h a 23:00h. El menú diari està disponible de dilluns a divendres de 13:00h a 16:00h.",
  menu_buffet_price_lunch: "16,99 € per persona",
  menu_buffet_schedule_lunch: "Dilluns a divendres de 13:00 h a 18:00 h",
  menu_buffet_price_dinner: "19,99 € per persona",
  menu_buffet_schedule_dinner: "Nits, caps de setmana i festius",
  menu_buffet_kids_note: "Infantil (3-8 anys): 11,50 €. No inclou beguda ni postres.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Restaurant Japonès Barcelona",
  blog_heading: "Blog Chibikokoro",
  blog_read_more: "Llegir més",
  blog_back: "← Tornar al blog",
  blog_reserve_cta: "Et ve de gust sushi? Reserva la teva taula ara",
  nav_restaurant: "Restaurant a Barcelona",
  footer_legal: "Legal",
  footer_social: "Segueix-nos",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navegació",
  local_seo_cta: "Descobreix el nostre restaurant japonès a Barcelona",
  delivery_takeaway_badge: "Delivery i Takeaway disponible",
  cta_delivery_title: "Demana per emportar o a domicili",
  cta_delivery_desc: "Gaudeix de la nostra cuina japonesa on vulguis. Comandes en línia amb lliurament a domicili o recollida al restaurant.",
};

const pt: TranslationKeys = {
  nav_home: "Início",
  nav_menu: "Cardápio",
  nav_gallery: "Galeria",
  nav_about: "Sobre nós",
  nav_reservations: "Reservas",
  nav_contact: "Contato",
  cta_reserve: "Reservar",
  cta_reserve_table: "Reservar mesa",
  cta_order_online: "Pedir online",
  cta_view_menu: "Ver cardápio",
  cta_call: "Ligar",
  cta_reserve_now: "Reservar agora",
  cta_confirm_reservation: "Confirmar reserva",
  hero_subtitle: "Japanese Restaurant · Barcelona",
  hero_title: "Autêntica experiência japonesa em Barcelona",
  hero_desc: "Ingredientes frescos, receitas tradicionais e um ambiente único no Bairro de Sants-Montjuïc.",
  about_label: "Nossa história",
  about_title: "Tradição e paixão desde 2018",
  about_p1: "Chibikokoro nasce no Bairro de Sants-Montjuïc com a missão de oferecer uma experiência gastronômica que fusiona sabores e aromas asiáticos com a autêntica culinária japonesa.",
  about_p2: "Cada prato é uma obra de arte, elaborado com ingredientes frescos selecionados diariamente e técnicas apuradas durante anos.",
  about_more: "Saber mais sobre Chibikokoro",
  featured_label: "Nosso cardápio",
  featured_title: "Pratos em destaque",
  featured_see_all: "Ver cardápio completo",
  benefits_label: "Por que nos escolher?",
  benefits_title: "Nossa essência",
  benefit_fresh: "Ingredientes frescos",
  benefit_fresh_desc: "Selecionamos diariamente os melhores produtos do mercado.",
  benefit_authentic: "Receitas autênticas",
  benefit_authentic_desc: "Técnicas japonesas tradicionais com um toque de fusão.",
  benefit_cozy: "Ambiente acolhedor",
  benefit_cozy_desc: "Um espaço íntimo pensado para desfrutar cada mordida.",
  benefit_online: "Pedidos online",
  benefit_online_desc: "Delivery e takeaway para desfrutar em casa.",
  gallery_label: "Nossa galeria",
  gallery_title: "A arte em cada prato",
  gallery_see_all: "Ver galeria completa",
  gallery_prev: "← Anterior",
  gallery_next: "Próximo →",
  gallery_close: "Fechar",
  gallery_page_title: "Galeria",
  gallery_page_heading: "Momentos Chibikokoro",
  reviews_label: "Avaliações",
  reviews_title: "O que dizem nossos clientes",
  reviews_on_google: "avaliações no Google",
  cta_banner_title: "Reserve sua mesa hoje",
  cta_banner_desc: "Viva uma experiência gastronômica inesquecível no coração de Barcelona.",
  menu_label: "Nosso cardápio",
  menu_title: "Sabores do Japão",
  menu_all: "Todos",
  menu_links_label: "Consulte também nossos cardápios completos:",
  menu_maker: "Menu Maker",
  menu_day: "Menu do Dia",
  menu_buffet: "Cardápio Buffet",
  menu_buffet_title: "Buffet livre",
  menu_buffet_price: "A partir de 16,99 € por pessoa",
  menu_buffet_kids: "Buffet Infantil: 11,50 €",
  menu_buffet_note: "Bebida não incluída. É obrigatório um pedido mínimo de 1 bebida por pessoa.",
  menu_buffet_schedule: "De segunda a domingo das 13:00 às 23:00",
  menu_daily_title: "Menu diário",
  menu_daily_price: "13,50 € por pessoa",
  menu_daily_note: "Bebida e sobremesa incluídas",
  menu_daily_schedule: "De segunda a sexta das 13:00 às 16:00",
  about_page_title: "Nossa História",
  about_since: "Desde 2018",
  about_passion_title: "Paixão pelo sushi",
  about_story_p1: "O restaurante japonês Sushi Chibikokoro foi criado em 2018 em um dos bairros residenciais mais tranquilos de Barcelona, o Bairro de Sants-Montjuïc.",
  about_story_p2: "Nosso restaurante nasce com a intenção de oferecer um estilo gastronômico que fusiona sabores e aromas asiáticos com a culinária japonesa mais autêntica.",
  about_story_p3: "Cada prato é elaborado com ingredientes frescos, selecionados diariamente para garantir a máxima qualidade e frescor em cada mordida.",
  about_story_p4: "Nossa receita para o sucesso é simples: qualidade e sabor que fazem nossos clientes voltarem sempre.",
  about_values_label: "Nossos valores",
  about_values_title: "O que nos define",
  about_val1: "Frescor",
  about_val1_desc: "Ingredientes selecionados todas as manhãs nos melhores mercados.",
  about_val2: "Autenticidade",
  about_val2_desc: "Técnicas japonesas tradicionais respeitadas em cada preparação.",
  about_val3: "Paixão",
  about_val3_desc: "Amor pela gastronomia japonesa em cada detalhe do serviço.",
  res_title: "Reservas",
  res_label: "Reservar mesa",
  res_heading: "Esperamos por você",
  res_name: "Nome",
  res_name_ph: "Seu nome completo",
  res_date: "Data",
  res_time: "Hora",
  res_time_ph: "Selecionar hora",
  res_guests: "Convidados",
  res_person: "pessoa",
  res_persons: "pessoas",
  res_phone: "Telefone",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Notas (opcional)",
  res_notes_ph: "Alergias, celebrações, preferências...",
  res_success_title: "Reserva recebida!",
  res_success_desc: "Confirmaremos sua reserva por telefone o mais rápido possível. Obrigado por escolher Chibikokoro!",
  contact_label: "Contato",
  contact_title: "Encontre-nos",
  contact_address: "Endereço",
  contact_phone: "Telefone",
  contact_email: "Email",
  contact_hours: "Horário",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Segunda — Domingo",
  footer_desc: "Autêntica culinária japonesa no coração do Bairro de Sants-Montjuïc. Ingredientes frescos, receitas tradicionais, experiência única.",
  footer_contact: "Contato",
  footer_hours: "Horário",
  footer_rights: "Todos os direitos reservados.",
  seo_home_title: "Chibikokoro – Japanese Restaurant em Barcelona",
  seo_home_desc: "Restaurante japonês em Barcelona com buffet livre a partir de 16,99€ e menu diário 13,50€.",
  buffet_section_label: "Nossas ofertas",
  buffet_section_title: "Buffet Livre e Menu Diário",
  buffet_per_person: "por pessoa",
  buffet_subtitle: "Desfrute sem limites da nossa seleção de sushi recém-preparado e especialidades japonesas autênticas.",
  buffet_point_1: "Sushi preparado na hora",
  buffet_point_2: "Ingredientes frescos e de alta qualidade",
  buffet_point_3: "Ampla variedade para todos os gostos",
  buffet_point_4: "Ambiente acolhedor e elegante",
  daily_ideal: "Ideal para um almoço rápido e de qualidade em Barcelona.",
  location_label: "Onde estamos",
  location_title: "Encontre-nos em Barcelona",
  seo_menu_title: "Cardápio — Chibikokoro | Sushi e Culinária Japonesa Barcelona",
  seo_menu_desc: "Descubra nosso cardápio de sushi, sashimi, nigiri, rolls e pratos quentes em Barcelona.",
  seo_gallery_title: "Galeria — Chibikokoro | Fotos do Restaurante",
  seo_gallery_desc: "Descubra nossa galeria de fotos em Chibikokoro, Barcelona.",
  seo_about_title: "Sobre Nós — Chibikokoro | Restaurante Japonês Barcelona",
  seo_about_desc: "Conheça a história de Chibikokoro. Desde 2018, culinária japonesa autêntica em Barcelona.",
  seo_res_title: "Reservas — Chibikokoro | Reserve Sua Mesa em Barcelona",
  seo_res_desc: "Reserve sua mesa no Chibikokoro. Restaurante japonês em Barcelona.",
  seo_contact_title: "Contato — Chibikokoro | Restaurante Japonês Barcelona",
  seo_contact_desc: "Entre em contato com Chibikokoro. Endereço, telefone e horários em Barcelona.",
  local_why_title: "Por que escolher nosso restaurante japonês em Barcelona?",
  local_authority_text: "Localizados no Bairro de Sants-Montjuïc, a poucos minutos da Estação de Sants e Plaça d'Espanya, Chibikokoro é a escolha ideal para o melhor sushi em Barcelona.",
  local_near_sants: "Perto da Estação de Sants e Plaça d'Espanya",
  local_directions: "Como chegar",
  reviews_leave_review: "Deixe sua avaliação no Google",
  seo_landing_title: "Restaurante Japonês em Barcelona | Chibikokoro – Sushi e Buffet",
  seo_landing_desc: "Descubra Chibikokoro, o melhor restaurante japonês em Barcelona. Buffet livre a partir de 16,99€, menu diário 13,50€.",
  landing_h1: "Restaurante Japonês em Barcelona – Chibikokoro",
  landing_intro: "Bem-vindo ao Chibikokoro, seu restaurante japonês de referência em Barcelona. Situados no Bairro de Sants-Montjuïc, oferecemos uma experiência gastronômica autêntica com sushi fresco.",
  landing_buffet_h2: "Buffet Livre Japonês em Barcelona – a partir de 16,99€",
  landing_buffet_text: "Nosso buffet livre japonês a partir de 16,99€ por pessoa (segunda a sexta das 13:00 às 18:00). Noites, fins de semana e feriados: 19,99€. Infantil dos 3 aos 8 anos: 11,50€. Não inclui bebida nem sobremesa.",
  landing_daily_h2: "Menu Diário em Barcelona – 13,50€",
  landing_daily_text: "De segunda a sexta, das 13:00 às 16:00, desfrute do nosso menu diário por 13,50€ com bebida e sobremesa incluídas.",
  landing_location_h2: "Onde Estamos – Restaurante Japonês perto da Estação de Sants",
  landing_location_text: "Chibikokoro fica na Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelona, no coração do Bairro de Sants-Montjuïc. A 5 minutos da Estação de Sants.",
  landing_why_h2: "Por que escolher Chibikokoro?",
  landing_why_p1: "Localização central em Barcelona, perto da Estação de Sants e Plaça d'Espanya",
  landing_why_p2: "Buffet livre japonês econômico e de alta qualidade",
  landing_why_p3: "Ingredientes frescos selecionados diariamente",
  landing_why_p4: "Ambiente acolhedor ideal para famílias e casais",
  landing_why_p5: "Pedidos online e reservas fáceis",
  landing_cta: "Reserve sua mesa e descubra por que somos um dos restaurantes japoneses favoritos de Barcelona.",
  geo_find_nearby: "Está perto? Descubra",
  geo_nearby_message: "Você está perto do nosso restaurante em Barcelona – Reserve agora!",
  geo_far_message: "Descubra nosso restaurante japonês em Barcelona",
  geo_directions: "Como chegar",
  geo_transport_sants: "A 5 min da Estação de Sants",
  geo_transport_espanya: "Perto da Plaça d'Espanya",
  geo_minutes_away: "min a pé",
  faq_label: "Perguntas frequentes",
  faq_title: "Tudo o que precisa saber",
  faq_q1: "Qual é o melhor restaurante japonês em Barcelona?",
  faq_a1: "Chibikokoro é um dos restaurantes japoneses mais bem avaliados de Barcelona, oferecendo sushi fresco, buffet livre e menu diário em ambiente acolhedor perto da Estação de Sants.",
  faq_q2: "Quanto custa o buffet livre japonês no Chibikokoro?",
  faq_a2: "No Chibikokoro pode desfrutar de um buffet livre japonês por 16,99€ por pessoa, de segunda a sexta das 13:00 às 18:00. Infantil dos 3 aos 8 anos, 11,50€. Noites, fins de semana e feriados: 19,99€. Não inclui bebida nem sobremesa.",
  faq_q3: "Onde comer sushi perto da Estação de Sants?",
  faq_a3: "Nosso restaurante fica na Carrer de Béjar, 64, Sants-Montjuïc, a poucos minutos a pé da Estação de Sants e Plaça d'Espanya.",
  faq_q4: "Existe menu diário japonês em Barcelona?",
  faq_a4: "Sim, oferecemos um menu diário por 13,50€ com bebida e sobremesa incluídas, de segunda a sexta das 13:00 às 16:00.",
  faq_q5: "É possível reservar mesa online no Chibikokoro?",
  faq_a5: "Sim, pode reservar mesa facilmente através do nosso site ou ligando para +34 931 46 30 45. Também aceitamos reservas por WhatsApp no +34 653 53 83 28.",
  faq_q6: "Qual é o horário do Chibikokoro?",
  faq_a6: "Estamos abertos de segunda a domingo das 13:00 às 23:00. O menu diário está disponível de segunda a sexta das 13:00 às 16:00.",
  menu_buffet_price_lunch: "16,99 € por pessoa",
  menu_buffet_schedule_lunch: "Segunda a sexta das 13:00 às 18:00",
  menu_buffet_price_dinner: "19,99 € por pessoa",
  menu_buffet_schedule_dinner: "Noites, fins de semana e feriados",
  menu_buffet_kids_note: "Infantil (3-8 anos): 11,50 €. Não inclui bebida nem sobremesa.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Restaurante Japonês Barcelona",
  blog_heading: "Blog Chibikokoro",
  blog_read_more: "Ler mais",
  blog_back: "← Voltar ao blog",
  blog_reserve_cta: "Quer sushi? Reserve sua mesa agora",
  nav_restaurant: "Restaurante em Barcelona",
  footer_legal: "Legal",
  footer_social: "Siga-nos",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navegação",
  local_seo_cta: "Descubra o nosso restaurante japonês em Barcelona",
  delivery_takeaway_badge: "Delivery e Takeaway disponível",
  cta_delivery_title: "Peça para levar ou ao domicílio",
  cta_delivery_desc: "Desfrute da nossa cozinha japonesa onde quiser. Pedidos online com entrega ao domicílio ou recolha no restaurante.",
};

const fr: TranslationKeys = {
  nav_home: "Accueil",
  nav_menu: "Carte",
  nav_gallery: "Galerie",
  nav_about: "À propos",
  nav_reservations: "Réservations",
  nav_contact: "Contact",
  cta_reserve: "Réserver",
  cta_reserve_table: "Réserver une table",
  cta_order_online: "Commander en ligne",
  cta_view_menu: "Voir le menu",
  cta_call: "Appeler",
  cta_reserve_now: "Réserver maintenant",
  cta_confirm_reservation: "Confirmer la réservation",
  hero_subtitle: "Japanese Restaurant · Barcelone",
  hero_title: "Authentique expérience japonaise à Barcelone",
  hero_desc: "Ingrédients frais, recettes traditionnelles et une ambiance unique dans le quartier de Sants-Montjuïc.",
  about_label: "Notre histoire",
  about_title: "Tradition et passion depuis 2018",
  about_p1: "Chibikokoro est né dans le quartier de Sants-Montjuïc avec la mission d'offrir une expérience gastronomique fusionnant les saveurs asiatiques avec la cuisine japonaise authentique.",
  about_p2: "Chaque plat est une œuvre d'art, élaboré avec des ingrédients frais sélectionnés quotidiennement.",
  about_more: "En savoir plus sur Chibikokoro",
  featured_label: "Notre carte",
  featured_title: "Plats vedettes",
  featured_see_all: "Voir la carte complète",
  benefits_label: "Pourquoi nous choisir ?",
  benefits_title: "Notre essence",
  benefit_fresh: "Ingrédients frais",
  benefit_fresh_desc: "Nous sélectionnons chaque jour les meilleurs produits du marché.",
  benefit_authentic: "Recettes authentiques",
  benefit_authentic_desc: "Techniques japonaises traditionnelles avec une touche de fusion.",
  benefit_cozy: "Ambiance chaleureuse",
  benefit_cozy_desc: "Un espace intime conçu pour savourer chaque bouchée.",
  benefit_online: "Commandes en ligne",
  benefit_online_desc: "Livraison et à emporter pour profiter chez vous.",
  gallery_label: "Notre galerie",
  gallery_title: "L'art dans chaque plat",
  gallery_see_all: "Voir la galerie complète",
  gallery_prev: "← Précédent",
  gallery_next: "Suivant →",
  gallery_close: "Fermer",
  gallery_page_title: "Galerie",
  gallery_page_heading: "Moments Chibikokoro",
  reviews_label: "Avis",
  reviews_title: "Ce que disent nos clients",
  reviews_on_google: "avis sur Google",
  cta_banner_title: "Réservez votre table aujourd'hui",
  cta_banner_desc: "Vivez une expérience gastronomique inoubliable au cœur de Barcelone.",
  menu_label: "Notre carte",
  menu_title: "Saveurs du Japon",
  menu_all: "Tous",
  menu_links_label: "Consultez également nos cartes complètes :",
  menu_maker: "Menu Maker",
  menu_day: "Menu du Jour",
  menu_buffet: "Carte Buffet",
  menu_buffet_title: "Buffet à volonté",
  menu_buffet_price: "À partir de 16,99 € par personne",
  menu_buffet_kids: "Buffet Enfant : 11,50 €",
  menu_buffet_note: "Boisson non incluse. Minimum 1 boisson par personne obligatoire.",
  menu_buffet_schedule: "Du lundi au dimanche de 13h00 à 23h00",
  menu_daily_title: "Menu du jour",
  menu_daily_price: "13,50 € par personne",
  menu_daily_note: "Boisson et dessert inclus",
  menu_daily_schedule: "Du lundi au vendredi de 13h00 à 16h00",
  about_page_title: "Notre Histoire",
  about_since: "Depuis 2018",
  about_passion_title: "Passion pour le sushi",
  about_story_p1: "Le restaurant japonais Sushi Chibikokoro a été créé en 2018 dans l'un des quartiers résidentiels les plus calmes de Barcelone, le quartier de Sants-Montjuïc.",
  about_story_p2: "Notre restaurant est né avec l'intention d'offrir un style gastronomique fusionnant les saveurs asiatiques avec la cuisine japonaise la plus authentique.",
  about_story_p3: "Chaque plat est préparé avec des ingrédients frais, sélectionnés quotidiennement pour garantir la plus haute qualité.",
  about_story_p4: "Notre recette du succès est simple : qualité et saveur qui font revenir nos clients encore et encore.",
  about_values_label: "Nos valeurs",
  about_values_title: "Ce qui nous définit",
  about_val1: "Fraîcheur",
  about_val1_desc: "Ingrédients sélectionnés chaque matin dans les meilleurs marchés.",
  about_val2: "Authenticité",
  about_val2_desc: "Techniques japonaises traditionnelles respectées dans chaque préparation.",
  about_val3: "Passion",
  about_val3_desc: "Amour de la gastronomie japonaise dans chaque détail du service.",
  res_title: "Réservations",
  res_label: "Réserver une table",
  res_heading: "Nous vous attendons",
  res_name: "Nom",
  res_name_ph: "Votre nom complet",
  res_date: "Date",
  res_time: "Heure",
  res_time_ph: "Sélectionner l'heure",
  res_guests: "Convives",
  res_person: "personne",
  res_persons: "personnes",
  res_phone: "Téléphone",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Notes (optionnel)",
  res_notes_ph: "Allergies, célébrations, préférences...",
  res_success_title: "Réservation reçue !",
  res_success_desc: "Nous confirmerons votre réservation par téléphone dès que possible. Merci d'avoir choisi Chibikokoro !",
  contact_label: "Contact",
  contact_title: "Trouvez-nous",
  contact_address: "Adresse",
  contact_phone: "Téléphone",
  contact_email: "Email",
  contact_hours: "Horaires",
  contact_closed: "",
  contact_schedule: "13h00 — 23h00",
  contact_days: "Lundi — Dimanche",
  footer_desc: "Authentique cuisine japonaise au cœur du quartier de Sants-Montjuïc. Ingrédients frais, recettes traditionnelles, expérience unique.",
  footer_contact: "Contact",
  footer_hours: "Horaires",
  footer_rights: "Tous droits réservés.",
  seo_home_title: "Chibikokoro – Japanese Restaurant à Barcelone",
  seo_home_desc: "Restaurant japonais à Barcelone avec buffet à volonté dès 16,99€ et menu du jour 13,50€.",
  buffet_section_label: "Nos offres",
  buffet_section_title: "Buffet à Volonté et Menu du Jour",
  buffet_per_person: "par personne",
  buffet_subtitle: "Profitez sans limites de notre sélection de sushi fraîchement préparé et de spécialités japonaises authentiques.",
  buffet_point_1: "Sushi préparé à la minute",
  buffet_point_2: "Ingrédients frais et de haute qualité",
  buffet_point_3: "Large variété pour tous les goûts",
  buffet_point_4: "Ambiance chaleureuse et élégante",
  daily_ideal: "Idéal pour un déjeuner rapide et de qualité à Barcelone.",
  location_label: "Où nous trouver",
  location_title: "Trouvez-nous à Barcelone",
  seo_menu_title: "Carte — Chibikokoro | Sushi et Cuisine Japonaise Barcelone",
  seo_menu_desc: "Découvrez notre carte de sushi, sashimi, nigiri, rolls et plats chauds à Barcelone.",
  seo_gallery_title: "Galerie — Chibikokoro | Photos du Restaurant",
  seo_gallery_desc: "Découvrez notre galerie photos à Chibikokoro, Barcelone.",
  seo_about_title: "À Propos — Chibikokoro | Restaurant Japonais Barcelone",
  seo_about_desc: "Découvrez l'histoire de Chibikokoro. Depuis 2018, cuisine japonaise authentique à Barcelone.",
  seo_res_title: "Réservations — Chibikokoro | Réservez Votre Table à Barcelone",
  seo_res_desc: "Réservez votre table chez Chibikokoro. Restaurant japonais à Barcelone.",
  seo_contact_title: "Contact — Chibikokoro | Restaurant Japonais Barcelone",
  seo_contact_desc: "Contactez Chibikokoro. Adresse, téléphone et horaires à Barcelone.",
  local_why_title: "Pourquoi choisir notre restaurant japonais à Barcelone ?",
  local_authority_text: "Situés dans le quartier de Sants-Montjuïc, à quelques minutes de la gare de Sants et de Plaça d'Espanya, Chibikokoro est le choix idéal pour le meilleur sushi à Barcelone.",
  local_near_sants: "Près de la gare de Sants et Plaça d'Espanya",
  local_directions: "Comment s'y rendre",
  reviews_leave_review: "Laissez-nous votre avis sur Google",
  seo_landing_title: "Restaurant Japonais à Barcelone | Chibikokoro – Sushi et Buffet",
  seo_landing_desc: "Découvrez Chibikokoro, le meilleur restaurant japonais à Barcelone. Buffet à volonté dès 16,99€, menu du jour 13,50€.",
  landing_h1: "Restaurant Japonais à Barcelone – Chibikokoro",
  landing_intro: "Bienvenue chez Chibikokoro, votre restaurant japonais de référence à Barcelone. Situés dans le quartier de Sants-Montjuïc, nous offrons une expérience gastronomique authentique.",
  landing_buffet_h2: "Buffet Japonais à Volonté à Barcelone – dès 16,99€",
  landing_buffet_text: "Notre buffet japonais à volonté dès 16,99€ par personne (lundi au vendredi de 13h à 18h). Soirs, weekends et jours fériés : 19,99€. Enfants 3-8 ans : 11,50€. Boisson et dessert non inclus.",
  landing_daily_h2: "Menu du Jour à Barcelone – 13,50€",
  landing_daily_text: "Du lundi au vendredi, de 13h00 à 16h00, profitez de notre menu du jour à 13,50€ avec boisson et dessert inclus.",
  landing_location_h2: "Où Nous Trouver – Restaurant Japonais près de la gare de Sants",
  landing_location_text: "Chibikokoro se trouve au Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelone, au cœur du quartier de Sants-Montjuïc. À 5 minutes de la gare de Sants.",
  landing_why_h2: "Pourquoi choisir Chibikokoro ?",
  landing_why_p1: "Emplacement central à Barcelone, près de la gare de Sants et Plaça d'Espanya",
  landing_why_p2: "Buffet japonais économique et de haute qualité",
  landing_why_p3: "Ingrédients frais sélectionnés chaque jour",
  landing_why_p4: "Ambiance chaleureuse idéale pour familles et couples",
  landing_why_p5: "Commandes en ligne et réservations faciles",
  landing_cta: "Réservez votre table et découvrez pourquoi nous sommes l'un des restaurants japonais préférés de Barcelone.",
  geo_find_nearby: "Êtes-vous proche ? Découvrez-le",
  geo_nearby_message: "Vous êtes près de notre restaurant à Barcelone – Réservez maintenant !",
  geo_far_message: "Découvrez notre restaurant japonais à Barcelone",
  geo_directions: "Comment s'y rendre",
  geo_transport_sants: "À 5 min de la gare de Sants",
  geo_transport_espanya: "Près de Plaça d'Espanya",
  geo_minutes_away: "min à pied",
  faq_label: "Questions fréquentes",
  faq_title: "Tout ce que vous devez savoir",
  faq_q1: "Quel est le meilleur restaurant japonais à Barcelone ?",
  faq_a1: "Chibikokoro est l'un des restaurants japonais les mieux notés de Barcelone, proposant sushi frais, buffet à volonté et menu du jour dans une ambiance chaleureuse près de la gare de Sants.",
  faq_q2: "Combien coûte le buffet japonais chez Chibikokoro ?",
  faq_a2: "Chez Chibikokoro, profitez d'un buffet japonais à volonté pour 16,99€ par personne, du lundi au vendredi de 13h à 18h. Enfants de 3 à 8 ans, 11,50€. Soirs, weekends et jours fériés : 19,99€. Boisson et dessert non inclus.",
  faq_q3: "Où manger des sushi près de la gare de Sants ?",
  faq_a3: "Notre restaurant se trouve au Carrer de Béjar, 64, Sants-Montjuïc, à quelques minutes à pied de la gare de Sants et de Plaça d'Espanya.",
  faq_q4: "Y a-t-il un menu du jour japonais à Barcelone ?",
  faq_a4: "Oui, nous proposons un menu du jour à 13,50€ avec boisson et dessert inclus, du lundi au vendredi de 13h à 16h.",
  faq_q5: "Peut-on réserver en ligne chez Chibikokoro ?",
  faq_a5: "Oui, vous pouvez réserver facilement via notre site ou en appelant le +34 931 46 30 45. Nous acceptons aussi les réservations par WhatsApp au +34 653 53 83 28.",
  faq_q6: "Quels sont les horaires de Chibikokoro ?",
  faq_a6: "Nous sommes ouverts du lundi au dimanche de 13h à 23h. Le menu du jour est disponible du lundi au vendredi de 13h à 16h.",
  menu_buffet_price_lunch: "16,99 € par personne",
  menu_buffet_schedule_lunch: "Lundi au vendredi de 13h00 à 18h00",
  menu_buffet_price_dinner: "19,99 € par personne",
  menu_buffet_schedule_dinner: "Soirs, weekends et jours fériés",
  menu_buffet_kids_note: "Enfants (3-8 ans) : 11,50 €. Boisson et dessert non inclus.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Restaurant Japonais Barcelone",
  blog_heading: "Blog Chibikokoro",
  blog_read_more: "Lire la suite",
  blog_back: "← Retour au blog",
  blog_reserve_cta: "Envie de sushi ? Réservez votre table maintenant",
  nav_restaurant: "Restaurant à Barcelone",
  footer_legal: "Mentions légales",
  footer_social: "Suivez-nous",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navigation",
  local_seo_cta: "Découvrez notre restaurant japonais à Barcelone",
  delivery_takeaway_badge: "Livraison et à emporter disponible",
  cta_delivery_title: "Commandez à emporter ou en livraison",
  cta_delivery_desc: "Savourez notre cuisine japonaise où que vous soyez. Commandes en ligne avec livraison à domicile ou retrait au restaurant.",
};

const it: TranslationKeys = {
  nav_home: "Home",
  nav_menu: "Menu",
  nav_gallery: "Galleria",
  nav_about: "Chi siamo",
  nav_reservations: "Prenotazioni",
  nav_contact: "Contatti",
  cta_reserve: "Prenota",
  cta_reserve_table: "Prenota un tavolo",
  cta_order_online: "Ordina online",
  cta_view_menu: "Vedi menu",
  cta_call: "Chiama",
  cta_reserve_now: "Prenota ora",
  cta_confirm_reservation: "Conferma prenotazione",
  hero_subtitle: "Japanese Restaurant · Barcellona",
  hero_title: "Autentica esperienza giapponese a Barcellona",
  hero_desc: "Ingredienti freschi, ricette tradizionali e un'atmosfera unica nel quartiere di Sants-Montjuïc.",
  about_label: "La nostra storia",
  about_title: "Tradizione e passione dal 2018",
  about_p1: "Chibikokoro nasce nel quartiere di Sants-Montjuïc con la missione di offrire un'esperienza gastronomica che fonde i sapori asiatici con l'autentica cucina giapponese.",
  about_p2: "Ogni piatto è un'opera d'arte, elaborato con ingredienti freschi selezionati quotidianamente.",
  about_more: "Scopri di più su Chibikokoro",
  featured_label: "Il nostro menu",
  featured_title: "Piatti in evidenza",
  featured_see_all: "Vedi menu completo",
  benefits_label: "Perché sceglierci?",
  benefits_title: "La nostra essenza",
  benefit_fresh: "Ingredienti freschi",
  benefit_fresh_desc: "Selezioniamo ogni giorno i migliori prodotti dal mercato.",
  benefit_authentic: "Ricette autentiche",
  benefit_authentic_desc: "Tecniche giapponesi tradizionali con un tocco di fusione.",
  benefit_cozy: "Atmosfera accogliente",
  benefit_cozy_desc: "Uno spazio intimo pensato per gustare ogni boccone.",
  benefit_online: "Ordini online",
  benefit_online_desc: "Consegna e asporto per gustare a casa.",
  gallery_label: "La nostra galleria",
  gallery_title: "L'arte in ogni piatto",
  gallery_see_all: "Vedi galleria completa",
  gallery_prev: "← Precedente",
  gallery_next: "Successivo →",
  gallery_close: "Chiudi",
  gallery_page_title: "Galleria",
  gallery_page_heading: "Momenti Chibikokoro",
  reviews_label: "Recensioni",
  reviews_title: "Cosa dicono i nostri clienti",
  reviews_on_google: "recensioni su Google",
  cta_banner_title: "Prenota il tuo tavolo oggi",
  cta_banner_desc: "Vivi un'esperienza gastronomica indimenticabile nel cuore di Barcellona.",
  menu_label: "Il nostro menu",
  menu_title: "Sapori del Giappone",
  menu_all: "Tutti",
  menu_links_label: "Consulta anche i nostri menu completi:",
  menu_maker: "Menu Maker",
  menu_day: "Menu del Giorno",
  menu_buffet: "Menu Buffet",
  menu_buffet_title: "Buffet libero",
  menu_buffet_price: "Da 16,99 € a persona",
  menu_buffet_kids: "Buffet Bambini: 11,50 €",
  menu_buffet_note: "Bevanda non inclusa. È obbligatorio un ordine minimo di 1 bevanda a persona.",
  menu_buffet_schedule: "Da lunedì a domenica dalle 13:00 alle 23:00",
  menu_daily_title: "Menu del giorno",
  menu_daily_price: "13,50 € a persona",
  menu_daily_note: "Bevanda e dolce inclusi",
  menu_daily_schedule: "Da lunedì a venerdì dalle 13:00 alle 16:00",
  about_page_title: "La Nostra Storia",
  about_since: "Dal 2018",
  about_passion_title: "Passione per il sushi",
  about_story_p1: "Il ristorante giapponese Sushi Chibikokoro è stato creato nel 2018 in uno dei quartieri residenziali più tranquilli di Barcellona, il quartiere di Sants-Montjuïc.",
  about_story_p2: "Il nostro ristorante nasce con l'intenzione di offrire uno stile gastronomico che fonde i sapori asiatici con la cucina giapponese più autentica.",
  about_story_p3: "Ogni piatto è preparato con ingredienti freschi, selezionati quotidianamente per garantire la massima qualità.",
  about_story_p4: "La nostra ricetta per il successo è semplice: qualità e sapore che fanno tornare i nostri clienti ancora e ancora.",
  about_values_label: "I nostri valori",
  about_values_title: "Cosa ci definisce",
  about_val1: "Freschezza",
  about_val1_desc: "Ingredienti selezionati ogni mattina nei migliori mercati.",
  about_val2: "Autenticità",
  about_val2_desc: "Tecniche giapponesi tradizionali rispettate in ogni preparazione.",
  about_val3: "Passione",
  about_val3_desc: "Amore per la gastronomia giapponese in ogni dettaglio del servizio.",
  res_title: "Prenotazioni",
  res_label: "Prenota un tavolo",
  res_heading: "Ti aspettiamo",
  res_name: "Nome",
  res_name_ph: "Il tuo nome completo",
  res_date: "Data",
  res_time: "Ora",
  res_time_ph: "Seleziona ora",
  res_guests: "Ospiti",
  res_person: "persona",
  res_persons: "persone",
  res_phone: "Telefono",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Note (opzionale)",
  res_notes_ph: "Allergie, celebrazioni, preferenze...",
  res_success_title: "Prenotazione ricevuta!",
  res_success_desc: "Confermeremo la tua prenotazione per telefono il prima possibile. Grazie per aver scelto Chibikokoro!",
  contact_label: "Contatti",
  contact_title: "Trovaci",
  contact_address: "Indirizzo",
  contact_phone: "Telefono",
  contact_email: "Email",
  contact_hours: "Orari",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Lunedì — Domenica",
  footer_desc: "Autentica cucina giapponese nel cuore del quartiere di Sants-Montjuïc. Ingredienti freschi, ricette tradizionali, esperienza unica.",
  footer_contact: "Contatti",
  footer_hours: "Orari",
  footer_rights: "Tutti i diritti riservati.",
  seo_home_title: "Chibikokoro – Japanese Restaurant a Barcellona",
  seo_home_desc: "Ristorante giapponese a Barcellona con buffet libero da 16,99€ e menu del giorno 13,50€.",
  buffet_section_label: "Le nostre offerte",
  buffet_section_title: "Buffet Libero e Menu del Giorno",
  buffet_per_person: "a persona",
  buffet_subtitle: "Goditi senza limiti la nostra selezione di sushi appena preparato e specialità giapponesi autentiche.",
  buffet_point_1: "Sushi preparato al momento",
  buffet_point_2: "Ingredienti freschi e di alta qualità",
  buffet_point_3: "Ampia varietà per tutti i gusti",
  buffet_point_4: "Atmosfera accogliente ed elegante",
  daily_ideal: "Ideale per un pranzo veloce e di qualità a Barcellona.",
  location_label: "Dove siamo",
  location_title: "Trovaci a Barcellona",
  seo_menu_title: "Menu — Chibikokoro | Sushi e Cucina Giapponese Barcellona",
  seo_menu_desc: "Scopri il nostro menu di sushi, sashimi, nigiri, rolls e piatti caldi a Barcellona.",
  seo_gallery_title: "Galleria — Chibikokoro | Foto del Ristorante",
  seo_gallery_desc: "Scopri la nostra galleria fotografica a Chibikokoro, Barcellona.",
  seo_about_title: "Chi Siamo — Chibikokoro | Ristorante Giapponese Barcellona",
  seo_about_desc: "Scopri la storia di Chibikokoro. Dal 2018, cucina giapponese autentica a Barcellona.",
  seo_res_title: "Prenotazioni — Chibikokoro | Prenota il Tuo Tavolo a Barcellona",
  seo_res_desc: "Prenota il tuo tavolo da Chibikokoro. Ristorante giapponese a Barcellona.",
  seo_contact_title: "Contatti — Chibikokoro | Ristorante Giapponese Barcellona",
  seo_contact_desc: "Contatta Chibikokoro. Indirizzo, telefono e orari a Barcellona.",
  local_why_title: "Perché scegliere il nostro ristorante giapponese a Barcellona?",
  local_authority_text: "Situati nel quartiere di Sants-Montjuïc, a pochi minuti dalla stazione di Sants e da Plaça d'Espanya, Chibikokoro è la scelta ideale per il miglior sushi a Barcellona.",
  local_near_sants: "Vicino alla stazione di Sants e Plaça d'Espanya",
  local_directions: "Come arrivare",
  reviews_leave_review: "Lasciaci una recensione su Google",
  seo_landing_title: "Ristorante Giapponese a Barcellona | Chibikokoro – Sushi e Buffet",
  seo_landing_desc: "Scopri Chibikokoro, il miglior ristorante giapponese a Barcellona. Buffet libero da 16,99€, menu del giorno 13,50€.",
  landing_h1: "Ristorante Giapponese a Barcellona – Chibikokoro",
  landing_intro: "Benvenuto da Chibikokoro, il tuo ristorante giapponese di riferimento a Barcellona. Situati nel quartiere di Sants-Montjuïc, offriamo un'esperienza gastronomica autentica.",
  landing_buffet_h2: "Buffet Giapponese a Barcellona – da 16,99€",
  landing_buffet_text: "Il nostro buffet giapponese da soli 16,99€ a persona (lunedì a venerdì dalle 13:00 alle 18:00). Sere, fine settimana e festivi: 19,99€. Bambini 3-8 anni: 11,50€. Bevanda e dolce non inclusi.",
  landing_daily_h2: "Menu del Giorno a Barcellona – 13,50€",
  landing_daily_text: "Da lunedì a venerdì, dalle 13:00 alle 16:00, goditi il nostro menu del giorno a 13,50€ con bevanda e dolce inclusi.",
  landing_location_h2: "Dove Siamo – Ristorante Giapponese vicino alla stazione di Sants",
  landing_location_text: "Chibikokoro si trova in Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcellona, nel cuore del quartiere di Sants-Montjuïc. A 5 minuti dalla stazione di Sants.",
  landing_why_h2: "Perché scegliere Chibikokoro?",
  landing_why_p1: "Posizione centrale a Barcellona, vicino alla stazione di Sants e Plaça d'Espanya",
  landing_why_p2: "Buffet giapponese economico e di alta qualità",
  landing_why_p3: "Ingredienti freschi selezionati ogni giorno",
  landing_why_p4: "Atmosfera accogliente ideale per famiglie e coppie",
  landing_why_p5: "Ordini online e prenotazioni facili",
  landing_cta: "Prenota il tuo tavolo e scopri perché siamo uno dei ristoranti giapponesi preferiti di Barcellona.",
  geo_find_nearby: "Sei vicino? Scoprilo",
  geo_nearby_message: "Sei vicino al nostro ristorante a Barcellona – Prenota ora!",
  geo_far_message: "Scopri il nostro ristorante giapponese a Barcellona",
  geo_directions: "Come arrivare",
  geo_transport_sants: "A 5 min dalla stazione di Sants",
  geo_transport_espanya: "Vicino a Plaça d'Espanya",
  geo_minutes_away: "min a piedi",
  faq_label: "Domande frequenti",
  faq_title: "Tutto quello che devi sapere",
  faq_q1: "Qual è il miglior ristorante giapponese a Barcellona?",
  faq_a1: "Chibikokoro è uno dei ristoranti giapponesi più apprezzati di Barcellona, con sushi fresco, buffet libero e menu del giorno in un'atmosfera accogliente vicino alla stazione di Sants.",
  faq_q2: "Quanto costa il buffet giapponese da Chibikokoro?",
  faq_a2: "Da Chibikokoro puoi goderti un buffet giapponese per 16,99€ a persona, lunedì a venerdì dalle 13:00 alle 18:00. Bambini 3-8 anni, 11,50€. Sere, fine settimana e festivi: 19,99€. Bevande e dolci non inclusi.",
  faq_q3: "Dove mangiare sushi vicino alla stazione di Sants?",
  faq_a3: "Il nostro ristorante si trova in Carrer de Béjar, 64, Sants-Montjuïc, a pochi minuti a piedi dalla stazione di Sants e da Plaça d'Espanya.",
  faq_q4: "C'è un menu del giorno giapponese a Barcellona?",
  faq_a4: "Sì, offriamo un menu del giorno a 13,50€ con bevanda e dolce inclusi, da lunedì a venerdì dalle 13:00 alle 16:00.",
  faq_q5: "Si può prenotare online da Chibikokoro?",
  faq_a5: "Sì, puoi prenotare facilmente tramite il nostro sito o chiamando il +34 931 46 30 45. Accettiamo anche prenotazioni via WhatsApp al +34 653 53 83 28.",
  faq_q6: "Qual è l'orario di Chibikokoro?",
  faq_a6: "Siamo aperti da lunedì a domenica dalle 13:00 alle 23:00. Il menu del giorno è disponibile da lunedì a venerdì dalle 13:00 alle 16:00.",
  menu_buffet_price_lunch: "16,99 € a persona",
  menu_buffet_schedule_lunch: "Lunedì a venerdì dalle 13:00 alle 18:00",
  menu_buffet_price_dinner: "19,99 € a persona",
  menu_buffet_schedule_dinner: "Sere, fine settimana e festivi",
  menu_buffet_kids_note: "Bambini (3-8 anni): 11,50 €. Bevanda e dolce non inclusi.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Ristorante Giapponese Barcellona",
  blog_heading: "Blog Chibikokoro",
  blog_read_more: "Leggi di più",
  blog_back: "← Torna al blog",
  blog_reserve_cta: "Voglia di sushi? Prenota il tuo tavolo ora",
  nav_restaurant: "Ristorante a Barcellona",
  footer_legal: "Legale",
  footer_social: "Seguici",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navigazione",
  local_seo_cta: "Scopri il nostro ristorante giapponese a Barcellona",
  delivery_takeaway_badge: "Delivery e Takeaway disponibile",
  cta_delivery_title: "Ordina da asporto o a domicilio",
  cta_delivery_desc: "Goditi la nostra cucina giapponese dove vuoi. Ordini online con consegna a domicilio o ritiro al ristorante.",
};

const de: TranslationKeys = {
  nav_home: "Startseite",
  nav_menu: "Speisekarte",
  nav_gallery: "Galerie",
  nav_about: "Über uns",
  nav_reservations: "Reservierung",
  nav_contact: "Kontakt",
  cta_reserve: "Reservieren",
  cta_reserve_table: "Tisch reservieren",
  cta_order_online: "Online bestellen",
  cta_view_menu: "Speisekarte ansehen",
  cta_call: "Anrufen",
  cta_reserve_now: "Jetzt reservieren",
  cta_confirm_reservation: "Reservierung bestätigen",
  hero_subtitle: "Japanese Restaurant · Barcelona",
  hero_title: "Authentisches japanisches Erlebnis in Barcelona",
  hero_desc: "Frische Zutaten, traditionelle Rezepte und eine einzigartige Atmosphäre im Viertel Sants-Montjuïc.",
  about_label: "Unsere Geschichte",
  about_title: "Tradition und Leidenschaft seit 2018",
  about_p1: "Chibikokoro entstand im Viertel Sants-Montjuïc mit der Mission, ein gastronomisches Erlebnis zu bieten, das asiatische Aromen mit authentischer japanischer Küche vereint.",
  about_p2: "Jedes Gericht ist ein Kunstwerk, zubereitet mit täglich frisch ausgewählten Zutaten und über Jahre verfeinerten Techniken.",
  about_more: "Mehr über Chibikokoro erfahren",
  featured_label: "Unsere Speisekarte",
  featured_title: "Ausgewählte Gerichte",
  featured_see_all: "Komplette Speisekarte",
  benefits_label: "Warum uns wählen?",
  benefits_title: "Unsere Essenz",
  benefit_fresh: "Frische Zutaten",
  benefit_fresh_desc: "Wir wählen täglich die besten Produkte vom Markt aus.",
  benefit_authentic: "Authentische Rezepte",
  benefit_authentic_desc: "Traditionelle japanische Techniken mit einem Hauch von Fusion.",
  benefit_cozy: "Gemütliche Atmosphäre",
  benefit_cozy_desc: "Ein intimer Raum, um jeden Bissen zu genießen.",
  benefit_online: "Online-Bestellungen",
  benefit_online_desc: "Lieferung und Abholung für den Genuss zu Hause.",
  gallery_label: "Unsere Galerie",
  gallery_title: "Kunst in jedem Gericht",
  gallery_see_all: "Komplette Galerie ansehen",
  gallery_prev: "← Zurück",
  gallery_next: "Weiter →",
  gallery_close: "Schließen",
  gallery_page_title: "Galerie",
  gallery_page_heading: "Chibikokoro Momente",
  reviews_label: "Bewertungen",
  reviews_title: "Was unsere Kunden sagen",
  reviews_on_google: "Bewertungen auf Google",
  cta_banner_title: "Reservieren Sie heute Ihren Tisch",
  cta_banner_desc: "Erleben Sie ein unvergessliches Gastronomieerlebnis im Herzen von Barcelona.",
  menu_label: "Unsere Speisekarte",
  menu_title: "Geschmack Japans",
  menu_all: "Alle",
  menu_links_label: "Siehe auch unsere kompletten Speisekarten:",
  menu_maker: "Menu Maker",
  menu_day: "Tagesmenü",
  menu_buffet: "Buffet-Karte",
  menu_buffet_title: "All-you-can-eat Buffet",
  menu_buffet_price: "Ab 16,99 € pro Person",
  menu_buffet_kids: "Kinder-Buffet: 11,50 €",
  menu_buffet_note: "Getränk nicht inbegriffen. Mindestens 1 Getränk pro Person erforderlich.",
  menu_buffet_schedule: "Montag bis Sonntag von 13:00 bis 23:00 Uhr",
  menu_daily_title: "Tagesmenü",
  menu_daily_price: "13,50 € pro Person",
  menu_daily_note: "Getränk und Dessert inklusive",
  menu_daily_schedule: "Montag bis Freitag von 13:00 bis 16:00 Uhr",
  about_page_title: "Unsere Geschichte",
  about_since: "Seit 2018",
  about_passion_title: "Leidenschaft für Sushi",
  about_story_p1: "Das japanische Restaurant Sushi Chibikokoro wurde 2018 in einem der ruhigsten Wohnviertel Barcelonas, dem Viertel Sants-Montjuïc, gegründet.",
  about_story_p2: "Unser Restaurant entstand mit der Absicht, einen gastronomischen Stil zu bieten, der asiatische Aromen mit der authentischsten japanischen Küche vereint.",
  about_story_p3: "Jedes Gericht wird mit frischen Zutaten zubereitet, die täglich ausgewählt werden, um höchste Qualität zu garantieren.",
  about_story_p4: "Unser Erfolgsrezept ist einfach: Qualität und Geschmack, die unsere Kunden immer wiederkommen lassen.",
  about_values_label: "Unsere Werte",
  about_values_title: "Was uns definiert",
  about_val1: "Frische",
  about_val1_desc: "Jeden Morgen auf den besten Märkten ausgewählte Zutaten.",
  about_val2: "Authentizität",
  about_val2_desc: "Traditionelle japanische Techniken, die in jeder Zubereitung respektiert werden.",
  about_val3: "Leidenschaft",
  about_val3_desc: "Liebe zur japanischen Gastronomie in jedem Detail unseres Services.",
  res_title: "Reservierung",
  res_label: "Tisch reservieren",
  res_heading: "Wir warten auf Sie",
  res_name: "Name",
  res_name_ph: "Ihr vollständiger Name",
  res_date: "Datum",
  res_time: "Uhrzeit",
  res_time_ph: "Uhrzeit auswählen",
  res_guests: "Gäste",
  res_person: "Person",
  res_persons: "Personen",
  res_phone: "Telefon",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Anmerkungen (optional)",
  res_notes_ph: "Allergien, Feiern, Präferenzen...",
  res_success_title: "Reservierung erhalten!",
  res_success_desc: "Wir bestätigen Ihre Reservierung so schnell wie möglich telefonisch. Danke, dass Sie Chibikokoro gewählt haben!",
  contact_label: "Kontakt",
  contact_title: "Finden Sie uns",
  contact_address: "Adresse",
  contact_phone: "Telefon",
  contact_email: "Email",
  contact_hours: "Öffnungszeiten",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Montag — Sonntag",
  footer_desc: "Authentische japanische Küche im Herzen des Viertels Sants-Montjuïc. Frische Zutaten, traditionelle Rezepte, einzigartiges Erlebnis.",
  footer_contact: "Kontakt",
  footer_hours: "Öffnungszeiten",
  footer_rights: "Alle Rechte vorbehalten.",
  seo_home_title: "Chibikokoro – Japanese Restaurant in Barcelona",
  seo_home_desc: "Japanisches Restaurant in Barcelona mit All-you-can-eat Buffet ab 16,99€ und Tagesmenü 13,50€.",
  buffet_section_label: "Unsere Angebote",
  buffet_section_title: "All-you-can-eat Buffet & Tagesmenü",
  buffet_per_person: "pro Person",
  buffet_subtitle: "Genießen Sie unbegrenzt unsere Auswahl an frisch zubereitetem Sushi und authentischen japanischen Spezialitäten.",
  buffet_point_1: "Sushi frisch zubereitet",
  buffet_point_2: "Frische Zutaten höchster Qualität",
  buffet_point_3: "Große Vielfalt für jeden Geschmack",
  buffet_point_4: "Gemütliche und elegante Atmosphäre",
  daily_ideal: "Ideal für ein schnelles, qualitativ hochwertiges Mittagessen in Barcelona.",
  location_label: "Wo wir sind",
  location_title: "Finden Sie uns in Barcelona",
  seo_menu_title: "Speisekarte — Chibikokoro | Sushi & Japanische Küche Barcelona",
  seo_menu_desc: "Entdecken Sie unsere Speisekarte mit Sushi, Sashimi, Nigiri und warmen Gerichten in Barcelona.",
  seo_gallery_title: "Galerie — Chibikokoro | Restaurantfotos",
  seo_gallery_desc: "Entdecken Sie unsere Fotogalerie bei Chibikokoro, Barcelona.",
  seo_about_title: "Über Uns — Chibikokoro | Japanisches Restaurant Barcelona",
  seo_about_desc: "Erfahren Sie die Geschichte von Chibikokoro. Seit 2018 authentische japanische Küche in Barcelona.",
  seo_res_title: "Reservierung — Chibikokoro | Reservieren Sie Ihren Tisch in Barcelona",
  seo_res_desc: "Reservieren Sie Ihren Tisch bei Chibikokoro. Japanisches Restaurant in Barcelona.",
  seo_contact_title: "Kontakt — Chibikokoro | Japanisches Restaurant Barcelona",
  seo_contact_desc: "Kontaktieren Sie Chibikokoro. Adresse, Telefon und Öffnungszeiten in Barcelona.",
  local_why_title: "Warum unser japanisches Restaurant in Barcelona wählen?",
  local_authority_text: "Im Viertel Sants-Montjuïc gelegen, nur wenige Minuten vom Bahnhof Sants und Plaça d'Espanya entfernt, ist Chibikokoro die ideale Wahl für das beste Sushi in Barcelona.",
  local_near_sants: "In der Nähe des Bahnhofs Sants und Plaça d'Espanya",
  local_directions: "Anfahrt",
  reviews_leave_review: "Hinterlassen Sie uns eine Bewertung bei Google",
  seo_landing_title: "Japanisches Restaurant in Barcelona | Chibikokoro – Sushi & Buffet",
  seo_landing_desc: "Entdecken Sie Chibikokoro, das beste japanische Restaurant in Barcelona. All-you-can-eat Buffet ab 16,99€, Tagesmenü 13,50€.",
  landing_h1: "Japanisches Restaurant in Barcelona – Chibikokoro",
  landing_intro: "Willkommen bei Chibikokoro, Ihrem japanischen Restaurant in Barcelona. Im Viertel Sants-Montjuïc gelegen, bieten wir ein authentisches Gastronomieerlebnis mit frischem Sushi.",
  landing_buffet_h2: "Japanisches All-you-can-eat Buffet in Barcelona – ab 16,99€",
  landing_buffet_text: "Unser japanisches All-you-can-eat Buffet ab 16,99€ pro Person (Mo-Fr 13:00-18:00). Abends, Wochenenden und Feiertage: 19,99€. Kinder 3-8 Jahre: 11,50€. Getränke nicht inbegriffen.",
  landing_daily_h2: "Tagesmenü in Barcelona – 13,50€",
  landing_daily_text: "Montag bis Freitag, von 13:00 bis 16:00 Uhr, genießen Sie unser Tagesmenü für 13,50€ inklusive Getränk und Dessert.",
  landing_location_h2: "Wo wir sind – Japanisches Restaurant nahe Bahnhof Sants",
  landing_location_text: "Chibikokoro befindet sich in der Carrer de Béjar, 64, Sants-Montjuïc, 08014 Barcelona, im Herzen des Viertels Sants-Montjuïc. 5 Minuten vom Bahnhof Sants entfernt.",
  landing_why_h2: "Warum Chibikokoro wählen?",
  landing_why_p1: "Zentrale Lage in Barcelona, nahe Bahnhof Sants und Plaça d'Espanya",
  landing_why_p2: "Erschwingliches japanisches All-you-can-eat Buffet hoher Qualität",
  landing_why_p3: "Täglich frisch ausgewählte Zutaten",
  landing_why_p4: "Gemütliche Atmosphäre ideal für Familien und Paare",
  landing_why_p5: "Einfache Online-Bestellung und Reservierung",
  landing_cta: "Reservieren Sie Ihren Tisch und entdecken Sie, warum wir eines der beliebtesten japanischen Restaurants in Barcelona sind.",
  geo_find_nearby: "Sind Sie in der Nähe? Finden Sie es heraus",
  geo_nearby_message: "Sie sind in der Nähe unseres Restaurants in Barcelona – Jetzt reservieren!",
  geo_far_message: "Entdecken Sie unser japanisches Restaurant in Barcelona",
  geo_directions: "Anfahrt",
  geo_transport_sants: "5 Min. vom Bahnhof Sants",
  geo_transport_espanya: "Nahe Plaça d'Espanya",
  geo_minutes_away: "Min. zu Fuß",
  faq_label: "Häufige Fragen",
  faq_title: "Alles was Sie wissen müssen",
  faq_q1: "Was ist das beste japanische Restaurant in Barcelona?",
  faq_a1: "Chibikokoro ist eines der am besten bewerteten japanischen Restaurants in Barcelona mit frischem Sushi, All-you-can-eat-Buffet und Tagesmenü in gemütlicher Atmosphäre nahe dem Bahnhof Sants.",
  faq_q2: "Wie viel kostet das japanische Buffet bei Chibikokoro?",
  faq_a2: "Bei Chibikokoro genießen Sie ein japanisches All-you-can-eat-Buffet ab 16,99€ pro Person, Mo-Fr 13:00-18:00. Kinder 3-8 Jahre: 11,50€. Abends, Wochenenden und Feiertage: 19,99€. Getränke nicht inbegriffen.",
  faq_q3: "Wo kann man Sushi nahe dem Bahnhof Sants essen?",
  faq_a3: "Unser Restaurant befindet sich in der Carrer de Béjar, 64, Sants-Montjuïc, nur wenige Gehminuten vom Bahnhof Sants und Plaça d'Espanya entfernt.",
  faq_q4: "Gibt es ein japanisches Tagesmenü in Barcelona?",
  faq_a4: "Ja, wir bieten ein Tagesmenü für 13,50€ inklusive Getränk und Dessert, Montag bis Freitag von 13:00 bis 16:00 Uhr.",
  faq_q5: "Kann man online bei Chibikokoro reservieren?",
  faq_a5: "Ja, Sie können einfach über unsere Website oder telefonisch unter +34 931 46 30 45 reservieren. Wir akzeptieren auch Reservierungen per WhatsApp unter +34 653 53 83 28.",
  faq_q6: "Was sind die Öffnungszeiten von Chibikokoro?",
  faq_a6: "Wir sind Montag bis Sonntag von 13:00 bis 23:00 Uhr geöffnet. Das Tagesmenü ist Montag bis Freitag von 13:00 bis 16:00 Uhr verfügbar.",
  menu_buffet_price_lunch: "16,99 € pro Person",
  menu_buffet_schedule_lunch: "Montag bis Freitag 13:00 bis 18:00 Uhr",
  menu_buffet_price_dinner: "19,99 € pro Person",
  menu_buffet_schedule_dinner: "Abends, Wochenenden und Feiertage",
  menu_buffet_kids_note: "Kinder (3-8 Jahre): 11,50 €. Getränke nicht inbegriffen.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Japanisches Restaurant Barcelona",
  blog_heading: "Chibikokoro Blog",
  blog_read_more: "Weiterlesen",
  blog_back: "← Zurück zum Blog",
  blog_reserve_cta: "Lust auf Sushi? Reservieren Sie jetzt Ihren Tisch",
  nav_restaurant: "Restaurant in Barcelona",
  footer_legal: "Rechtliches",
  footer_social: "Folgen Sie uns",
  footer_google_maps: "Google Maps",
  footer_navigation: "Navigation",
  local_seo_cta: "Entdecken Sie unser japanisches Restaurant in Barcelona",
  delivery_takeaway_badge: "Lieferung & Abholung verfügbar",
  cta_delivery_title: "Bestellen Sie zum Mitnehmen oder Liefern",
  cta_delivery_desc: "Genießen Sie unsere japanische Küche, wo immer Sie möchten. Online-Bestellungen mit Lieferung oder Abholung im Restaurant.",
};

const ru: TranslationKeys = {
  nav_home: "Главная",
  nav_menu: "Меню",
  nav_gallery: "Галерея",
  nav_about: "О нас",
  nav_reservations: "Бронирование",
  nav_contact: "Контакты",
  cta_reserve: "Забронировать",
  cta_reserve_table: "Забронировать столик",
  cta_order_online: "Заказать онлайн",
  cta_view_menu: "Смотреть меню",
  cta_call: "Позвонить",
  cta_reserve_now: "Забронировать сейчас",
  cta_confirm_reservation: "Подтвердить бронь",
  hero_subtitle: "Japanese Restaurant · Барселона",
  hero_title: "Подлинный японский опыт в Барселоне",
  hero_desc: "Свежие ингредиенты, традиционные рецепты и уникальная атмосфера в районе Сантс.",
  about_label: "Наша история",
  about_title: "Традиции и страсть с 2018 года",
  about_p1: "Chibikokoro родился в районе Сантс с миссией предложить гастрономический опыт, сочетающий азиатские ароматы с подлинной японской кухней.",
  about_p2: "Каждое блюдо — произведение искусства, приготовленное из свежих ингредиентов, отобранных ежедневно.",
  about_more: "Узнать больше о Chibikokoro",
  featured_label: "Наше меню",
  featured_title: "Избранные блюда",
  featured_see_all: "Полное меню",
  benefits_label: "Почему выбирают нас?",
  benefits_title: "Наша суть",
  benefit_fresh: "Свежие ингредиенты",
  benefit_fresh_desc: "Мы ежедневно отбираем лучшие продукты на рынке.",
  benefit_authentic: "Подлинные рецепты",
  benefit_authentic_desc: "Традиционные японские техники с нотками фьюжн.",
  benefit_cozy: "Уютная атмосфера",
  benefit_cozy_desc: "Камерное пространство для наслаждения каждым кусочком.",
  benefit_online: "Онлайн-заказы",
  benefit_online_desc: "Доставка и самовывоз для наслаждения дома.",
  gallery_label: "Наша галерея",
  gallery_title: "Искусство в каждом блюде",
  gallery_see_all: "Полная галерея",
  gallery_prev: "← Назад",
  gallery_next: "Далее →",
  gallery_close: "Закрыть",
  gallery_page_title: "Галерея",
  gallery_page_heading: "Моменты Chibikokoro",
  reviews_label: "Отзывы",
  reviews_title: "Что говорят наши клиенты",
  reviews_on_google: "отзывов в Google",
  cta_banner_title: "Забронируйте столик сегодня",
  cta_banner_desc: "Переживите незабываемый гастрономический опыт в сердце Барселоны.",
  menu_label: "Наше меню",
  menu_title: "Вкусы Японии",
  menu_all: "Все",
  menu_links_label: "Также смотрите наши полные меню:",
  menu_maker: "Menu Maker",
  menu_day: "Меню дня",
  menu_buffet: "Меню Буфет",
  menu_buffet_title: "Шведский стол",
  menu_buffet_price: "От 16,99 € с человека",
  menu_buffet_kids: "Детский буфет: 11,50 €",
  menu_buffet_note: "Напиток не включён. Минимум 1 напиток на человека обязателен.",
  menu_buffet_schedule: "С понедельника по воскресенье с 13:00 до 23:00",
  menu_daily_title: "Дневное меню",
  menu_daily_price: "13,50 € с человека",
  menu_daily_note: "Напиток и десерт включены",
  menu_daily_schedule: "С понедельника по пятницу с 13:00 до 16:00",
  about_page_title: "Наша история",
  about_since: "С 2018 года",
  about_passion_title: "Страсть к суши",
  about_story_p1: "Японский ресторан Sushi Chibikokoro был создан в 2018 году в одном из самых тихих жилых районов Барселоны — районе Сантс.",
  about_story_p2: "Наш ресторан родился с намерением предложить гастрономический стиль, сочетающий азиатские ароматы с самой подлинной японской кухней.",
  about_story_p3: "Каждое блюдо готовится из свежих ингредиентов, ежедневно отбираемых для гарантии высочайшего качества.",
  about_story_p4: "Наш рецепт успеха прост: качество и вкус, которые заставляют наших клиентов возвращаться снова и снова.",
  about_values_label: "Наши ценности",
  about_values_title: "Что нас определяет",
  about_val1: "Свежесть",
  about_val1_desc: "Ингредиенты, отобранные каждое утро на лучших рынках.",
  about_val2: "Подлинность",
  about_val2_desc: "Традиционные японские техники, уважаемые в каждом приготовлении.",
  about_val3: "Страсть",
  about_val3_desc: "Любовь к японской гастрономии в каждой детали обслуживания.",
  res_title: "Бронирование",
  res_label: "Забронировать столик",
  res_heading: "Мы ждём вас",
  res_name: "Имя",
  res_name_ph: "Ваше полное имя",
  res_date: "Дата",
  res_time: "Время",
  res_time_ph: "Выберите время",
  res_guests: "Гости",
  res_person: "человек",
  res_persons: "человек",
  res_phone: "Телефон",
  res_phone_ph: "+34 600 000 000",
  res_notes: "Заметки (необязательно)",
  res_notes_ph: "Аллергии, праздники, предпочтения...",
  res_success_title: "Бронь получена!",
  res_success_desc: "Мы подтвердим вашу бронь по телефону как можно скорее. Спасибо, что выбрали Chibikokoro!",
  contact_label: "Контакты",
  contact_title: "Найдите нас",
  contact_address: "Адрес",
  contact_phone: "Телефон",
  contact_email: "Email",
  contact_hours: "Часы работы",
  contact_closed: "",
  contact_schedule: "13:00 — 23:00",
  contact_days: "Понедельник — Воскресенье",
  footer_desc: "Подлинная японская кухня в сердце района Сантс. Свежие ингредиенты, традиционные рецепты, уникальный опыт.",
  footer_contact: "Контакты",
  footer_hours: "Часы работы",
  footer_rights: "Все права защищены.",
  seo_home_title: "Chibikokoro – Japanese Restaurant в Барселоне",
  seo_home_desc: "Японский ресторан в Барселоне со шведским столом от 16,99€ и дневным меню 13,50€.",
  buffet_section_label: "Наши предложения",
  buffet_section_title: "Шведский стол и Дневное меню",
  buffet_per_person: "с человека",
  buffet_subtitle: "Наслаждайтесь без ограничений нашей подборкой свежеприготовленных суши и подлинных японских блюд.",
  buffet_point_1: "Суши, приготовленные на месте",
  buffet_point_2: "Свежие, высококачественные ингредиенты",
  buffet_point_3: "Широкий выбор на любой вкус",
  buffet_point_4: "Уютная и элегантная атмосфера",
  daily_ideal: "Идеально для быстрого и качественного обеда в Барселоне.",
  location_label: "Где мы находимся",
  location_title: "Найдите нас в Барселоне",
  seo_menu_title: "Меню — Chibikokoro | Суши и японская кухня Барселона",
  seo_menu_desc: "Откройте наше меню суши, сашими, нигири и горячих блюд в Барселоне.",
  seo_gallery_title: "Галерея — Chibikokoro | Фото ресторана",
  seo_gallery_desc: "Откройте нашу фотогалерею в Chibikokoro, Барселона.",
  seo_about_title: "О нас — Chibikokoro | Японский ресторан Барселона",
  seo_about_desc: "Узнайте историю Chibikokoro. С 2018 года подлинная японская кухня в Барселоне.",
  seo_res_title: "Бронирование — Chibikokoro | Забронируйте столик в Барселоне",
  seo_res_desc: "Забронируйте столик в Chibikokoro. Японский ресторан в Барселоне.",
  seo_contact_title: "Контакты — Chibikokoro | Японский ресторан Барселона",
  seo_contact_desc: "Свяжитесь с Chibikokoro. Адрес, телефон и часы работы в Барселоне.",
  local_why_title: "Почему выбирают наш японский ресторан в Барселоне?",
  local_authority_text: "Расположенные в районе Сантс, в нескольких минутах от станции Сантс и площади Испании, Chibikokoro — идеальный выбор для лучших суши в Барселоне.",
  local_near_sants: "Рядом со станцией Сантс и площадью Испании",
  local_directions: "Как добраться",
  reviews_leave_review: "Оставьте отзыв в Google",
  seo_landing_title: "Японский ресторан в Барселоне | Chibikokoro – Суши и Буфет",
  seo_landing_desc: "Откройте Chibikokoro, лучший японский ресторан в Барселоне. Шведский стол от 16,99€, дневное меню 13,50€.",
  landing_h1: "Японский ресторан в Барселоне – Chibikokoro",
  landing_intro: "Добро пожаловать в Chibikokoro, ваш японский ресторан в Барселоне. Расположенные в районе Сантс, мы предлагаем подлинный гастрономический опыт со свежими суши.",
  landing_buffet_h2: "Японский шведский стол в Барселоне – от 16,99€",
  landing_buffet_text: "Наш японский шведский стол от 16,99€ с человека (пн-пт 13:00-18:00). Вечера, выходные и праздники: 19,99€. Детский (3-8 лет): 11,50€. Напитки не включены.",
  landing_daily_h2: "Дневное меню в Барселоне – 13,50€",
  landing_daily_text: "С понедельника по пятницу, с 13:00 до 16:00, наслаждайтесь нашим дневным меню за 13,50€ с напитком и десертом.",
  landing_location_h2: "Где мы – Японский ресторан рядом с Сантс",
  landing_location_text: "Chibikokoro находится по адресу Carrer de Béjar, 64, 08014 Барселона, в сердце района Сантс. 5 минут от станции Сантс.",
  landing_why_h2: "Почему выбирают Chibikokoro?",
  landing_why_p1: "Центральное расположение в Барселоне, рядом с Сантс и площадью Испании",
  landing_why_p2: "Доступный японский шведский стол высокого качества",
  landing_why_p3: "Ежедневно отбираемые свежие ингредиенты",
  landing_why_p4: "Уютная атмосфера для семей и пар",
  landing_why_p5: "Удобные онлайн-заказы и бронирование",
  landing_cta: "Забронируйте столик и узнайте, почему мы один из любимых японских ресторанов Барселоны.",
  geo_find_nearby: "Вы рядом? Узнайте",
  geo_nearby_message: "Вы рядом с нашим рестораном в Барселоне – Забронируйте сейчас!",
  geo_far_message: "Откройте наш японский ресторан в Барселоне",
  geo_directions: "Как добраться",
  geo_transport_sants: "5 мин от станции Сантс",
  geo_transport_espanya: "Рядом с площадью Испании",
  geo_minutes_away: "мин пешком",
  faq_label: "Часто задаваемые вопросы",
  faq_title: "Всё, что нужно знать",
  faq_q1: "Какой лучший японский ресторан в Барселоне?",
  faq_a1: "Chibikokoro — один из самых высоко оценённых японских ресторанов Барселоны, предлагающий свежие суши, шведский стол и дневное меню в уютной атмосфере рядом со станцией Сантс.",
  faq_q2: "Сколько стоит японский шведский стол в Chibikokoro?",
  faq_a2: "В Chibikokoro вы можете насладиться японским шведским столом от 16,99€ с человека (пн-пт 13:00-18:00). Детский (3-8 лет): 11,50€. Вечера, выходные и праздники: 19,99€. Напитки не включены.",
  faq_q3: "Где поесть суши рядом со станцией Сантс?",
  faq_a3: "Наш ресторан расположен по адресу Carrer de Béjar, 64, Sants-Montjuïc, в нескольких минутах ходьбы от станции Сантс и площади Испании.",
  faq_q4: "Есть ли японское дневное меню в Барселоне?",
  faq_a4: "Да, мы предлагаем дневное меню за 13,50€ с напитком и десертом, с понедельника по пятницу с 13:00 до 16:00.",
  faq_q5: "Можно ли забронировать столик онлайн в Chibikokoro?",
  faq_a5: "Да, вы можете легко забронировать столик через наш сайт или по телефону +34 931 46 30 45. Мы также принимаем бронирования через WhatsApp: +34 653 53 83 28.",
  faq_q6: "Какие часы работы Chibikokoro?",
  faq_a6: "Мы открыты с понедельника по воскресенье с 13:00 до 23:00. Дневное меню доступно с понедельника по пятницу с 13:00 до 16:00.",
  menu_buffet_price_lunch: "16,99 € с человека",
  menu_buffet_schedule_lunch: "Понедельник-пятница с 13:00 до 18:00",
  menu_buffet_price_dinner: "19,99 € с человека",
  menu_buffet_schedule_dinner: "Вечера, выходные и праздники",
  menu_buffet_kids_note: "Детский (3-8 лет): 11,50 €. Напитки не включены.",
  nav_blog: "Blog",
  blog_title: "Blog — Chibikokoro | Японский ресторан Барселона",
  blog_heading: "Блог Chibikokoro",
  blog_read_more: "Читать далее",
  blog_back: "← Назад к блогу",
  blog_reserve_cta: "Хотите суши? Забронируйте столик сейчас",
  nav_restaurant: "Ресторан в Барселоне",
  footer_legal: "Правовая информация",
  footer_social: "Подписывайтесь",
  footer_google_maps: "Google Maps",
  footer_navigation: "Навигация",
  local_seo_cta: "Откройте наш японский ресторан в Барселоне",
  delivery_takeaway_badge: "Доставка и самовывоз доступны",
  cta_delivery_title: "Закажите на вынос или с доставкой",
  cta_delivery_desc: "Наслаждайтесь японской кухней, где бы вы ни находились. Онлайн-заказы с доставкой на дом или самовывозом.",
};

export const translations: Record<Language, TranslationKeys> = { es, en, ca, pt, fr, it, de, ru };
